/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * To change the format of this file, modify `createIconDocsNew` in icon-build-process/src/create-icon-docs.tsx.
 *
 * @codegen <<SignedSource::6e26cf59349fd809e4c0617937b4ea70>>
 * @codegenCommand yarn build:icon-glyphs
 */
interface metadata {
	/**
	 * Default component name for the icon
	 */
	componentName: string;

	/**
	 * Package path to the icon component
	 */
	package: string;

	/**
	 * The category of the icon:
	 * - 'single-purpose' icons should only be used for the purposes listed in the 'usage' field
	 * - 'multi-purpose' icons are designed for various use cases and don't have the same usage restrictions
	 */
	categorization: 'single-purpose' | 'multi-purpose';

	/**
	 * Usage guidelines for the icon. For single-purpose icons,
	 */
	usage?: string;

	/**
	 * Additional keywords used to assist in search/lookup of an icon
	 */
	keywords: string[];

	/**
	 * The name of the team owning the icon
	 */
	team: string;

	/**
	 * The status of the icon
	 */
	status?: 'draft' | 'ready-to-publish' | 'published' | 'modified' | 'deprecated';

	/**
	 * Contact slack channel for the team owning the icon
	 */
	slackChannel?: string;

	/**
	 * A replacement icon if this icon has been deprecated
	 */
	replacement?: {
		name: string;
		location: '@atlaskit/icon' | '@atlaskit/icon-lab' | '@atlassian/icon-private';
	};

	/**
	 * Whether the icon should be recommended as a small icon
	 */
	shouldRecommendSmallIcon?: boolean;
}

const metadata: Record<string, metadata> = {
	'ai-agent-add': {
		keywords: [
			'ai-agent-add',
			'aiagentadd',
			'icon',
			'icon-lab',
			'agent',
			'ai agent',
			'add',
			'plus',
			'ai',
		],
		componentName: 'AiAgentAddIcon',
		package: '@atlaskit/icon-lab/core/ai-agent-add',
		categorization: 'single-purpose',
		usage: 'Reserved for adding AI agents in Atlassian apps',
		team: 'Jira frontier',
		status: 'published',
	},
	'ai-bot': {
		keywords: ['ai-bot', 'aibot', 'icon', 'icon-lab', 'AI', 'chat bot'],
		componentName: 'AiBotIcon',
		package: '@atlaskit/icon-lab/core/ai-bot',
		categorization: 'single-purpose',
		usage: 'Reserved for representing AI bots.',
		team: 'Design System Team',
		status: 'published',
	},
	'ai-compute': {
		keywords: [
			'ai-compute',
			'aicompute',
			'icon',
			'icon-lab',
			'AI',
			'brain',
			'circuit',
			'memory',
			'compute',
		],
		componentName: 'AiComputeIcon',
		package: '@atlaskit/icon-lab/core/ai-compute',
		categorization: 'single-purpose',
		usage: 'Reserved for representing AI compute and memory.',
		team: 'Design System Team',
		status: 'published',
	},
	'ai-generative-audio-briefing': {
		keywords: [
			'ai-generative-audio-briefing',
			'aigenerativeaudiobriefing',
			'icon',
			'icon-lab',
			'audio briefing',
			'breifing',
			'podcast',
			'headphones',
			'AI',
		],
		componentName: 'AiGenerativeAudioBriefingIcon',
		package: '@atlaskit/icon-lab/core/ai-generative-audio-briefing',
		categorization: 'single-purpose',
		usage:
			'Reserved for Audio Briefings, a new feature launching within Confluence to help people develop an expanded awareness on a topic by generating AI-powered podcasts about their work.',
		team: 'Confluence AI Audio',
		status: 'published',
	},
	'ai-generative-chapters': {
		keywords: [
			'ai-generative-chapters',
			'aigenerativechapters',
			'icon',
			'icon-lab',
			'book',
			'AI',
			'automation',
		],
		componentName: 'AiGenerativeChaptersIcon',
		package: '@atlaskit/icon-lab/core/ai-generative-chapters',
		categorization: 'single-purpose',
		usage: 'Reserved for auto chapters functionality in Loom.',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'ai-generative-cleanup': {
		keywords: [
			'ai-generative-cleanup',
			'aigenerativecleanup',
			'icon',
			'icon-lab',
			'broom',
			'tidy',
			'clean up',
		],
		componentName: 'AiGenerativeCleanupIcon',
		package: '@atlaskit/icon-lab/core/ai-generative-cleanup',
		categorization: 'single-purpose',
		usage: 'Reserved for automated cleanup and tidy functionality',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'ai-generative-remix': {
		keywords: [
			'ai-generative-remix',
			'aigenerativeremix',
			'icon',
			'icon-lab',
			'transform',
			'AI visualization',
			'remix with rovo',
		],
		componentName: 'AiGenerativeRemixIcon',
		package: '@atlaskit/icon-lab/core/ai-generative-remix',
		categorization: 'single-purpose',
		usage: 'Reserved for Remix with Rovo',
		team: 'Confluence Malleable UI (MaUI)',
		status: 'published',
		slackChannel: '#maui-ux',
	},
	'ai-generative-remove': {
		keywords: [
			'ai-generative-remove',
			'aigenerativeremove',
			'icon',
			'icon-lab',
			'eraser',
			'AI',
			'automation',
		],
		componentName: 'AiGenerativeRemoveIcon',
		package: '@atlaskit/icon-lab/core/ai-generative-remove',
		categorization: 'single-purpose',
		usage: 'Reserved for remove filler words functionality in Loom',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'ai-generative-remove-silence': {
		keywords: [
			'ai-generative-remove-silence',
			'aigenerativeremovesilence',
			'icon',
			'icon-lab',
			'empty',
			'AI',
			'automation',
			'pauses',
			'silences',
		],
		componentName: 'AiGenerativeRemoveSilenceIcon',
		package: '@atlaskit/icon-lab/core/ai-generative-remove-silence',
		categorization: 'single-purpose',
		usage: 'Reserved for silence removal functionality in Loom',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'ai-generative-slides': {
		keywords: [
			'ai-generative-slides',
			'aigenerativeslides',
			'icon',
			'icon-lab',
			'slides',
			'AI slides',
			'presentation',
		],
		componentName: 'AiGenerativeSlidesIcon',
		package: '@atlaskit/icon-lab/core/ai-generative-slides',
		categorization: 'single-purpose',
		usage: 'Reserved for Confluence Slides',
		team: 'Confluence Malleable UI (MaUI)',
		status: 'published',
		slackChannel: '#maui-UX',
	},
	'ai-generative-text': {
		keywords: [
			'ai-generative-text',
			'aigenerativetext',
			'icon',
			'icon-lab',
			'pencil',
			'AI',
			'automation',
		],
		componentName: 'AiGenerativeTextIcon',
		package: '@atlaskit/icon-lab/core/ai-generative-text',
		categorization: 'single-purpose',
		usage: 'Reserved for auto draft functionality in Loom.',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'ai-generative-text-title': {
		keywords: [
			'ai-generative-text-title',
			'aigenerativetexttitle',
			'icon',
			'icon-lab',
			'text',
			'AI',
			'automation',
			'header',
		],
		componentName: 'AiGenerativeTextTitleIcon',
		package: '@atlaskit/icon-lab/core/ai-generative-text-title',
		categorization: 'single-purpose',
		usage: 'Reserved for auto titles functionality in Loom',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'ai-model': {
		keywords: [
			'ai-model',
			'aimodel',
			'icon',
			'icon-lab',
			'machine learning',
			'AI',
			'model',
			'brain',
			'reasoning',
			'LLM',
			'large language model',
		],
		componentName: 'AiModelIcon',
		package: '@atlaskit/icon-lab/core/ai-model',
		categorization: 'single-purpose',
		usage: 'Reserved for representing large language and reasoning models.',
		team: 'Compass',
		status: 'published',
	},
	'ai-search': {
		keywords: [
			'ai-search',
			'aisearch',
			'icon',
			'icon-lab',
			'search sparkle',
			'rovo sparkle',
			'search',
			'rovo',
			'AI search',
		],
		componentName: 'AiSearchIcon',
		package: '@atlaskit/icon-lab/core/ai-search',
		categorization: 'single-purpose',
		usage: 'Reserved for search interactions powered by Rovo/AI.',
		team: 'Rovo and AI Design Team',
		status: 'published',
		slackChannel: '#rad-design',
	},
	'align-content-bottom': {
		keywords: [
			'align-content-bottom',
			'aligncontentbottom',
			'icon',
			'icon-lab',
			'align',
			'alignment',
			'content',
			'bottom',
			'vertical',
		],
		componentName: 'AlignContentBottomIcon',
		package: '@atlaskit/icon-lab/core/align-content-bottom',
		categorization: 'multi-purpose',
		usage: 'Used for aligning bottom edges of content in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'align-content-center-horizontal': {
		keywords: [
			'align-content-center-horizontal',
			'aligncontentcenterhorizontal',
			'icon',
			'icon-lab',
			'align',
			'alignment',
			'content',
			'center',
			'middle',
			'horizontal',
		],
		componentName: 'AlignContentCenterHorizontalIcon',
		package: '@atlaskit/icon-lab/core/align-content-center-horizontal',
		categorization: 'multi-purpose',
		usage: 'Used for aligning horizontal centers of content in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'align-content-center-vertical': {
		keywords: [
			'align-content-center-vertical',
			'aligncontentcentervertical',
			'icon',
			'icon-lab',
			'align',
			'alignment',
			'content',
			'center',
			'vertical',
		],
		componentName: 'AlignContentCenterVerticalIcon',
		package: '@atlaskit/icon-lab/core/align-content-center-vertical',
		categorization: 'multi-purpose',
		usage: 'Used for aligning vertical centers of content in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'align-content-left': {
		keywords: [
			'align-content-left',
			'aligncontentleft',
			'icon',
			'icon-lab',
			'align',
			'alignment',
			'content',
			'left',
			'horizontal',
		],
		componentName: 'AlignContentLeftIcon',
		package: '@atlaskit/icon-lab/core/align-content-left',
		categorization: 'multi-purpose',
		usage: 'Used for aligning left edges of content in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'align-content-right': {
		keywords: [
			'align-content-right',
			'aligncontentright',
			'icon',
			'icon-lab',
			'align',
			'alignment',
			'content',
			'right',
			'horizontal',
		],
		componentName: 'AlignContentRightIcon',
		package: '@atlaskit/icon-lab/core/align-content-right',
		categorization: 'multi-purpose',
		usage: 'Used for aligning right edges of content in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'align-content-top': {
		keywords: [
			'align-content-top',
			'aligncontenttop',
			'icon',
			'icon-lab',
			'align',
			'alignment',
			'content',
			'top',
			'vertical',
		],
		componentName: 'AlignContentTopIcon',
		package: '@atlaskit/icon-lab/core/align-content-top',
		categorization: 'multi-purpose',
		usage: 'Used for aligning top edges of content in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'align-position-bottom': {
		keywords: [
			'align-position-bottom',
			'alignpositionbottom',
			'icon',
			'icon-lab',
			'align',
			'alignment',
			'middle',
			'text position',
			'bottom',
			'vertical',
		],
		componentName: 'AlignPositionBottomIcon',
		package: '@atlaskit/icon-lab/core/align-position-bottom',
		categorization: 'multi-purpose',
		usage: 'Bottom-aligned text position within sticky notes in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'align-position-center-vertical': {
		keywords: [
			'align-position-center-vertical',
			'alignpositioncentervertical',
			'icon',
			'icon-lab',
			'align',
			'alignment',
			'middle',
			'center',
			'text position',
			'vertical',
		],
		componentName: 'AlignPositionCenterVerticalIcon',
		package: '@atlaskit/icon-lab/core/align-position-center-vertical',
		categorization: 'multi-purpose',
		usage: 'Center-aligned text position within sticky notes in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'align-position-top': {
		keywords: [
			'align-position-top',
			'alignpositiontop',
			'icon',
			'icon-lab',
			'align',
			'alignment',
			'top edge',
			'text position',
			'vertical',
		],
		componentName: 'AlignPositionTopIcon',
		package: '@atlaskit/icon-lab/core/align-position-top',
		categorization: 'multi-purpose',
		usage: 'Top-aligned text position within sticky notes in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'approval-start': {
		keywords: [
			'approval-start',
			'approvalstart',
			'icon',
			'icon-lab',
			'approval',
			'reapprove',
			'approve',
			'reapproval',
		],
		componentName: 'ApprovalStartIcon',
		package: '@atlaskit/icon-lab/core/approval-start',
		categorization: 'single-purpose',
		usage: 'Reserved for indicating content that is entering into an approval workflow.',
		team: 'Confluence Admin',
		status: 'published',
	},
	'arrow-curved-down-left': {
		keywords: [
			'arrow-curved-down-left',
			'arrowcurveddownleft',
			'icon',
			'icon-lab',
			'arrow',
			'curved',
			'turn',
			'rotate',
			'corner',
		],
		componentName: 'ArrowCurvedDownLeftIcon',
		package: '@atlaskit/icon-lab/core/arrow-curved-down-left',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-curved-down-right': {
		keywords: [
			'arrow-curved-down-right',
			'arrowcurveddownright',
			'icon',
			'icon-lab',
			'arrow',
			'curved',
			'turn',
			'rotate',
			'corner',
		],
		componentName: 'ArrowCurvedDownRightIcon',
		package: '@atlaskit/icon-lab/core/arrow-curved-down-right',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-curved-left-down': {
		keywords: [
			'arrow-curved-left-down',
			'arrowcurvedleftdown',
			'icon',
			'icon-lab',
			'arrow',
			'curved',
			'turn',
			'rotate',
			'corner',
		],
		componentName: 'ArrowCurvedLeftDownIcon',
		package: '@atlaskit/icon-lab/core/arrow-curved-left-down',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-curved-left-up': {
		keywords: [
			'arrow-curved-left-up',
			'arrowcurvedleftup',
			'icon',
			'icon-lab',
			'arrow',
			'curved',
			'turn',
			'rotate',
			'corner',
		],
		componentName: 'ArrowCurvedLeftUpIcon',
		package: '@atlaskit/icon-lab/core/arrow-curved-left-up',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-curved-right-down': {
		keywords: [
			'arrow-curved-right-down',
			'arrowcurvedrightdown',
			'icon',
			'icon-lab',
			'arrow',
			'curved',
			'turn',
			'rotate',
			'corner',
		],
		componentName: 'ArrowCurvedRightDownIcon',
		package: '@atlaskit/icon-lab/core/arrow-curved-right-down',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-curved-right-up': {
		keywords: [
			'arrow-curved-right-up',
			'arrowcurvedrightup',
			'icon',
			'icon-lab',
			'arrow',
			'curved',
			'turn',
			'rotate',
			'corner',
		],
		componentName: 'ArrowCurvedRightUpIcon',
		package: '@atlaskit/icon-lab/core/arrow-curved-right-up',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-curved-up-left': {
		keywords: [
			'arrow-curved-up-left',
			'arrowcurvedupleft',
			'icon',
			'icon-lab',
			'arrow',
			'curved',
			'turn',
			'rotate',
			'corner',
		],
		componentName: 'ArrowCurvedUpLeftIcon',
		package: '@atlaskit/icon-lab/core/arrow-curved-up-left',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-curved-up-right': {
		keywords: [
			'arrow-curved-up-right',
			'arrowcurvedupright',
			'icon',
			'icon-lab',
			'arrow',
			'curved',
			'turn',
			'rotate',
			'corner',
		],
		componentName: 'ArrowCurvedUpRightIcon',
		package: '@atlaskit/icon-lab/core/arrow-curved-up-right',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'arrow-end': {
		keywords: [
			'arrow-end',
			'arrowend',
			'icon',
			'icon-lab',
			'move to end',
			'move to back',
			'move to last position',
			'move to far right',
		],
		componentName: 'ArrowEndIcon',
		package: '@atlaskit/icon-lab/core/arrow-end',
		categorization: 'multi-purpose',
		usage:
			'Used for moving an object to the back or ending of a container, moving a column to last position',
		team: 'Strategy Collection',
		status: 'published',
		slackChannel: '#sc-design',
	},
	'arrow-start': {
		keywords: [
			'arrow-start',
			'arrowstart',
			'icon',
			'icon-lab',
			'move to front',
			'move to start',
			'move to far left',
			'move to first position',
		],
		componentName: 'ArrowStartIcon',
		package: '@atlaskit/icon-lab/core/arrow-start',
		categorization: 'multi-purpose',
		usage:
			'Used for moving an object to the front or beginning of a container, moving a column to first position',
		team: 'Strategy Collection',
		status: 'published',
		slackChannel: '#sc-design',
	},
	'arrow-up-circle': {
		keywords: ['arrow-up-circle', 'arrowupcircle', 'icon', 'icon-lab', 'arrow', 'upgrade', 'up'],
		componentName: 'ArrowUpCircleIcon',
		package: '@atlaskit/icon-lab/core/arrow-up-circle',
		categorization: 'multi-purpose',
		usage: 'Known uses: upgrading to a paid plan',
		team: 'Growth',
		status: 'published',
	},
	'arrows-diagonal-up-right-down-left': {
		keywords: [
			'arrows-diagonal-up-right-down-left',
			'arrowsdiagonaluprightdownleft',
			'icon',
			'icon-lab',
			'Arrows',
			'Switch',
			'Space',
			'Swap',
			'crossflow',
		],
		componentName: 'ArrowsDiagonalUpRightDownLeftIcon',
		package: '@atlaskit/icon-lab/core/arrows-diagonal-up-right-down-left',
		categorization: 'multi-purpose',
		usage: 'Used within Jira Pages to connect or switch to a Space or page.',
		team: 'Confluence Integrations',
		status: 'published',
	},
	ask: {
		keywords: [
			'ask',
			'icon',
			'icon-lab',
			'collaboration',
			'hand shake',
			'ask',
			'focus',
			'structured request',
			'negotation',
			'dependency',
		],
		componentName: 'AskIcon',
		package: '@atlaskit/icon-lab/core/ask',
		categorization: 'single-purpose',
		usage:
			'Reserved for representing Asks in Focus. An ask is structured request made by one team or user to another, representing work needed to complete other work.',
		team: 'Focus',
		status: 'published',
	},
	'assets-data-manager': {
		keywords: [
			'assets-data-manager',
			'assetsdatamanager',
			'icon',
			'icon-lab',
			'data manager',
			'assets',
			'CMDB',
			'configuration management database',
		],
		componentName: 'AssetsDataManagerIcon',
		package: '@atlaskit/icon-lab/core/assets-data-manager',
		categorization: 'single-purpose',
		usage: 'Reserved for JSM Assets.',
		team: 'Assets',
		status: 'published',
	},
	'assets-graph': {
		keywords: ['assets-graph', 'assetsgraph', 'icon', 'icon-lab', 'assets', 'graph'],
		componentName: 'AssetsGraphIcon',
		package: '@atlaskit/icon-lab/core/assets-graph',
		categorization: 'single-purpose',
		usage: 'Reserved for representing Assets graph',
		team: 'Assets',
		status: 'published',
	},
	'assets-object': {
		keywords: ['assets-object', 'assetsobject', 'icon', 'icon-lab', 'assets', 'object', 'box'],
		componentName: 'AssetsObjectIcon',
		package: '@atlaskit/icon-lab/core/assets-object',
		categorization: 'single-purpose',
		usage: 'Reserved for representing objects in Assets.',
		team: 'Assets',
		status: 'published',
	},
	'assets-object-type': {
		keywords: [
			'assets-object-type',
			'assetsobjecttype',
			'icon',
			'icon-lab',
			'assets',
			'object type',
			'collection',
		],
		componentName: 'AssetsObjectTypeIcon',
		package: '@atlaskit/icon-lab/core/assets-object-type',
		categorization: 'single-purpose',
		usage: 'Reserved for representing object types in Assets.',
		team: 'Assets',
		status: 'published',
	},
	'assets-schema': {
		keywords: [
			'assets-schema',
			'assetsschema',
			'icon',
			'icon-lab',
			'assets',
			'CMDB',
			'configuration management database',
		],
		componentName: 'AssetsSchemaIcon',
		package: '@atlaskit/icon-lab/core/assets-schema',
		categorization: 'single-purpose',
		usage: 'Reserved for representing schema in Assets.',
		team: 'Assets',
		status: 'published',
	},
	atlassian: {
		keywords: ['atlassian', 'icon', 'icon-lab', 'Atlassian', 'logo'],
		componentName: 'AtlassianIcon',
		package: '@atlaskit/icon-lab/core/atlassian',
		categorization: 'multi-purpose',
		usage: 'Known uses: Atlassian branded emojis on emoji picker in Editor.',
		team: 'Editor',
		status: 'published',
	},
	atom: {
		keywords: ['atom', 'icon', 'icon-lab', 'atom', 'molecule', 'atomic design'],
		componentName: 'AtomIcon',
		package: '@atlaskit/icon-lab/core/atom',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'audio-waveform': {
		keywords: [
			'audio-waveform',
			'audiowaveform',
			'icon',
			'icon-lab',
			'waveform',
			'audio',
			'soundwave',
			'dialogue',
			'speak',
		],
		componentName: 'AudioWaveformIcon',
		package: '@atlaskit/icon-lab/core/audio-waveform',
		categorization: 'multi-purpose',
		usage: 'Known uses: show waveform editor in Loom.',
		team: 'Loom',
		status: 'published',
	},
	'beach-umbrella': {
		keywords: [
			'beach-umbrella',
			'beachumbrella',
			'icon',
			'icon-lab',
			'vacation',
			'beach umbrella',
			'sun shade',
			'holiday',
		],
		componentName: 'BeachUmbrellaIcon',
		package: '@atlaskit/icon-lab/core/beach-umbrella',
		categorization: 'multi-purpose',
		usage: 'User-selectable icon choice for calendars',
		team: 'Growth Buy',
		status: 'published',
	},
	bed: {
		keywords: ['bed', 'icon', 'icon-lab', 'bed', 'sleep'],
		componentName: 'BedIcon',
		package: '@atlaskit/icon-lab/core/bed',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	bird: {
		keywords: ['bird', 'icon', 'icon-lab', 'bird', 'robin', 'tweet'],
		componentName: 'BirdIcon',
		package: '@atlaskit/icon-lab/core/bird',
		categorization: 'multi-purpose',
		usage:
			'A fun little bird drawn as a legacy to Jesse Bauer (a huge bird nerd) who crafted the iconography system.',
		team: 'Design System Team',
		status: 'published',
	},
	'blast-radius': {
		keywords: ['blast-radius', 'blastradius', 'icon', 'icon-lab', 'blast radius', 'impact area'],
		componentName: 'BlastRadiusIcon',
		package: '@atlaskit/icon-lab/core/blast-radius',
		categorization: 'single-purpose',
		usage: 'Reserved for representing blast radius in Object Graph.',
		team: 'JSM',
		status: 'published',
	},
	'block-synced': {
		keywords: [
			'block-synced',
			'blocksynced',
			'icon',
			'icon-lab',
			'sync',
			'synced',
			'content block',
			'snippet',
		],
		componentName: 'BlockSyncedIcon',
		package: '@atlaskit/icon-lab/core/block-synced',
		categorization: 'single-purpose',
		usage: 'Reserved for syncing content blocks in Editor experiences.',
		team: 'Editor Platform',
		status: 'published',
	},
	bluetooth: {
		keywords: ['bluetooth', 'icon', 'icon-lab', 'bluetooth', 'connectivity', 'bt'],
		componentName: 'BluetoothIcon',
		package: '@atlaskit/icon-lab/core/bluetooth',
		categorization: 'single-purpose',
		usage: 'Reserved for Bluetooth',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	blur: {
		keywords: ['blur', 'icon', 'icon-lab'],
		componentName: 'BlurIcon',
		package: '@atlaskit/icon-lab/core/blur',
		categorization: 'single-purpose',
		usage: 'Reserved for blurring an element in Loom',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'book-open': {
		keywords: ['book-open', 'bookopen', 'icon', 'icon-lab', 'book', 'knowledgebase article'],
		componentName: 'BookOpenIcon',
		package: '@atlaskit/icon-lab/core/book-open',
		categorization: 'multi-purpose',
		usage: 'Known uses: None',
		team: 'Design System Team',
		status: 'published',
	},
	boolean: {
		keywords: ['boolean', 'icon', 'icon-lab', 'true', 'false', 'binary', 'boolean', 'on', 'off'],
		componentName: 'BooleanIcon',
		package: '@atlaskit/icon-lab/core/boolean',
		categorization: 'single-purpose',
		usage: 'Reserved for representing boolean data types and operations.',
		team: 'Data Experiences (AVP)',
		status: 'published',
	},
	'browser-extension': {
		keywords: [
			'browser-extension',
			'browserextension',
			'icon',
			'icon-lab',
			'extension',
			'puzzle piece',
			'add on',
			'jigsaw',
			'chrome web store',
		],
		componentName: 'BrowserExtensionIcon',
		package: '@atlaskit/icon-lab/core/browser-extension',
		categorization: 'single-purpose',
		usage: 'Reserved for chrome extensions',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	calculate: {
		keywords: ['calculate', 'icon', 'icon-lab', 'Calculate', 'databases', 'summation'],
		componentName: 'CalculateIcon',
		package: '@atlaskit/icon-lab/core/calculate',
		categorization: 'single-purpose',
		usage: 'Calculate for databases',
		team: 'Databases',
		status: 'published',
	},
	capability: {
		keywords: ['capability', 'icon', 'icon-lab', 'capability', 'capabilities', 'instance'],
		componentName: 'CapabilityIcon',
		package: '@atlaskit/icon-lab/core/capability',
		categorization: 'single-purpose',
		usage: 'Reserved for representing capabilities.',
		team: 'Compass',
		status: 'published',
	},
	cart: {
		keywords: ['cart', 'icon', 'icon-lab', 'shopping cart', 'shopping trolley', 'checkout'],
		componentName: 'CartIcon',
		package: '@atlaskit/icon-lab/core/cart',
		categorization: 'single-purpose',
		usage: 'Reserved for representing the cart in online purchase experiences.',
		team: 'Creative',
		status: 'published',
	},
	'chart-area': {
		keywords: [
			'chart-area',
			'chartarea',
			'icon',
			'icon-lab',
			'chart',
			'area',
			'analytics',
			'graph',
		],
		componentName: 'ChartAreaIcon',
		package: '@atlaskit/icon-lab/core/chart-area',
		categorization: 'multi-purpose',
		usage: 'Known uses: Area charts',
		team: 'Data Experiences',
		status: 'published',
	},
	'chart-bar-line': {
		keywords: [
			'chart-bar-line',
			'chartbarline',
			'icon',
			'icon-lab',
			'chart',
			'bar',
			'line',
			'trend',
			'graph',
			'analytics',
		],
		componentName: 'ChartBarLineIcon',
		package: '@atlaskit/icon-lab/core/chart-bar-line',
		categorization: 'multi-purpose',
		usage: 'Known uses: Bar charts with trend lines',
		team: 'Data Experiences',
		status: 'published',
	},
	'chart-box-plot': {
		keywords: [
			'chart-box-plot',
			'chartboxplot',
			'icon',
			'icon-lab',
			'chart',
			'box plot',
			'whisker',
			'distribution',
			'quartile',
			'analytics',
		],
		componentName: 'ChartBoxPlotIcon',
		package: '@atlaskit/icon-lab/core/chart-box-plot',
		categorization: 'multi-purpose',
		usage: 'Known uses: Box plot charts',
		team: 'Data Experiences',
		status: 'published',
	},
	'chart-bullet': {
		keywords: [
			'chart-bullet',
			'chartbullet',
			'icon',
			'icon-lab',
			'bullet',
			'chart',
			'graph',
			'primary measure',
		],
		componentName: 'ChartBulletIcon',
		package: '@atlaskit/icon-lab/core/chart-bullet',
		categorization: 'multi-purpose',
		usage: 'Known uses: Bullet charts or graphs',
		team: 'Data Experiences',
		status: 'published',
	},
	'chart-extrapolate': {
		keywords: [
			'chart-extrapolate',
			'chartextrapolate',
			'icon',
			'icon-lab',
			'chart',
			'trend',
			'extrapolate',
			'analytics',
		],
		componentName: 'ChartExtrapolateIcon',
		package: '@atlaskit/icon-lab/core/chart-extrapolate',
		categorization: 'multi-purpose',
		usage: 'Known uses: Chart trend extrapolation in Analytics.',
		team: 'Data Experiences',
		status: 'published',
	},
	'chart-funnel': {
		keywords: [
			'chart-funnel',
			'chartfunnel',
			'icon',
			'icon-lab',
			'chart',
			'funnel',
			'sales process',
			'revenue',
		],
		componentName: 'ChartFunnelIcon',
		package: '@atlaskit/icon-lab/core/chart-funnel',
		categorization: 'multi-purpose',
		usage: 'Known uses: Chart funnels',
		team: 'Data Experiences',
		status: 'published',
	},
	'chart-scatter-plot': {
		keywords: [
			'chart-scatter-plot',
			'chartscatterplot',
			'icon',
			'icon-lab',
			'chart',
			'scatter',
			'dot plot',
			'distribution',
			'analytics',
		],
		componentName: 'ChartScatterPlotIcon',
		package: '@atlaskit/icon-lab/core/chart-scatter-plot',
		categorization: 'multi-purpose',
		usage: 'Known uses: Scatter plot chart',
		team: 'Data Experiences',
		status: 'published',
	},
	'clock-alarm': {
		keywords: ['clock-alarm', 'clockalarm', 'icon', 'icon-lab', 'alarm clock'],
		componentName: 'ClockAlarmIcon',
		package: '@atlaskit/icon-lab/core/clock-alarm',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	cloud: {
		keywords: ['cloud', 'icon', 'icon-lab', 'cloud'],
		componentName: 'CloudIcon',
		package: '@atlaskit/icon-lab/core/cloud',
		categorization: 'multi-purpose',
		usage: 'Known uses: Cloud resource, Cloud online',
		team: 'Compass',
		status: 'published',
	},
	'cloud-fortified': {
		keywords: [
			'cloud-fortified',
			'cloudfortified',
			'icon',
			'icon-lab',
			'Cloud fortified',
			'trust',
			'program',
			'security',
			'badge',
		],
		componentName: 'CloudFortifiedIcon',
		package: '@atlaskit/icon-lab/core/cloud-fortified',
		categorization: 'single-purpose',
		usage: 'Reserved for representing Cloud Fortified apps on Marketplace.',
		team: 'Ecosystem-Marketplace',
		status: 'published',
		slackChannel: '#unified-store-design',
	},
	'cloud-offline': {
		keywords: [
			'cloud-offline',
			'cloudoffline',
			'icon',
			'icon-lab',
			'cloud',
			'offline',
			'disconnected',
			'strikethrough',
		],
		componentName: 'CloudOfflineIcon',
		package: '@atlaskit/icon-lab/core/cloud-offline',
		categorization: 'single-purpose',
		usage: "Reserved for showing when a connection can\'t be established to the cloud.",
		team: 'Content Types',
		status: 'published',
	},
	'cloud-saved': {
		keywords: [
			'cloud-saved',
			'cloudsaved',
			'icon',
			'icon-lab',
			'cloud',
			'check mark',
			'saved',
			'success',
		],
		componentName: 'CloudSavedIcon',
		package: '@atlaskit/icon-lab/core/cloud-saved',
		categorization: 'single-purpose',
		usage: 'Reserved for showing saved status after successful cloud synchronisation.',
		team: 'Content Types',
		status: 'published',
	},
	coins: {
		keywords: ['coins', 'icon', 'icon-lab', 'money', 'loose change', 'currency'],
		componentName: 'CoinsIcon',
		package: '@atlaskit/icon-lab/core/coins',
		categorization: 'multi-purpose',
		usage: 'Multi purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'colour-none': {
		keywords: [
			'colour-none',
			'colournone',
			'icon',
			'icon-lab',
			'Colour',
			'Color',
			'Remove',
			'None',
			'Colour picker',
		],
		componentName: 'ColourNoneIcon',
		package: '@atlaskit/icon-lab/core/colour-none',
		categorization: 'single-purpose',
		usage: "Remove colours from Whiteboard\'s colour picker",
		team: 'Whiteboards',
		status: 'published',
	},
	compare: {
		keywords: ['compare', 'icon', 'icon-lab', 'compare', 'git', 'bitbucket', 'diff'],
		componentName: 'CompareIcon',
		package: '@atlaskit/icon-lab/core/compare',
		categorization: 'single-purpose',
		usage: 'Reserved for compare functionality in Bitbucket.',
		team: 'Bitbucket',
		status: 'published',
	},
	'compass-hinged': {
		keywords: [
			'compass-hinged',
			'compasshinged',
			'icon',
			'icon-lab',
			'compass',
			'calipers',
			'divider',
		],
		componentName: 'CompassHingedIcon',
		package: '@atlaskit/icon-lab/core/compass-hinged',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'continue-when': {
		keywords: ['continue-when', 'continuewhen', 'icon', 'icon-lab'],
		componentName: 'ContinueWhenIcon',
		package: '@atlaskit/icon-lab/core/continue-when',
		categorization: 'single-purpose',
		usage: 'Reserved for continue when delay in automation.',
		team: 'Automation',
		status: 'published',
		slackChannel: '#help-automation-design',
	},
	'corner-radius-rounded': {
		keywords: [
			'corner-radius-rounded',
			'cornerradiusrounded',
			'icon',
			'icon-lab',
			'corner radius',
			'radii',
			'rounded corner',
			'round corners',
		],
		componentName: 'CornerRadiusRoundedIcon',
		package: '@atlaskit/icon-lab/core/corner-radius-rounded',
		categorization: 'single-purpose',
		usage:
			'Reserved for rounded corners option for experiences that offer user customization of corner radius.',
		team: 'Unified Hubs',
		status: 'published',
	},
	'corner-radius-squared': {
		keywords: [
			'corner-radius-squared',
			'cornerradiussquared',
			'icon',
			'icon-lab',
			'corner radius',
			'radii',
			'squared corner',
			'square corners',
		],
		componentName: 'CornerRadiusSquaredIcon',
		package: '@atlaskit/icon-lab/core/corner-radius-squared',
		categorization: 'single-purpose',
		usage:
			'Reserved for squared corners option for experiences that offer user customization of corner radius.',
		team: 'Unified Hubs',
		status: 'published',
	},
	'cross-octagon': {
		keywords: [
			'cross-octagon',
			'crossoctagon',
			'icon',
			'icon-lab',
			'cross',
			'stop',
			'block',
			'octagon',
		],
		componentName: 'CrossOctagonIcon',
		package: '@atlaskit/icon-lab/core/cross-octagon',
		categorization: 'multi-purpose',
		usage: 'Multi purpose',
		team: 'Design System Team',
		status: 'published',
	},
	cursor: {
		keywords: ['cursor', 'icon', 'icon-lab', 'Whiteboards', 'Cursor'],
		componentName: 'CursorIcon',
		package: '@atlaskit/icon-lab/core/cursor',
		categorization: 'multi-purpose',
		usage: 'Selecting the cursor in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'cursor-strikethrough': {
		keywords: [
			'cursor-strikethrough',
			'cursorstrikethrough',
			'icon',
			'icon-lab',
			'Cursor',
			'Cursors',
			'Hide cursor',
			'Whiteboard cursor',
			'Cursor strikethrough',
		],
		componentName: 'CursorStrikethroughIcon',
		package: '@atlaskit/icon-lab/core/cursor-strikethrough',
		categorization: 'multi-purpose',
		usage: 'Hide collaborator cursors in the Whiteboard',
		team: 'Whiteboards',
		status: 'published',
	},
	'dash-double': {
		keywords: [
			'dash-double',
			'dashdouble',
			'icon',
			'icon-lab',
			'double dash',
			'no change',
			'unchanged value',
			'same value',
		],
		componentName: 'DashDoubleIcon',
		package: '@atlaskit/icon-lab/core/dash-double',
		categorization: 'multi-purpose',
		usage: 'Known uses: representing no change or keeping a value as-is.',
		team: 'Strategy Collection',
		status: 'published',
		slackChannel: '#sc-design',
	},
	'data-app': {
		keywords: ['data-app', 'dataapp', 'icon', 'icon-lab', 'database', 'data product', 'data app'],
		componentName: 'DataAppIcon',
		package: '@atlaskit/icon-lab/core/data-app',
		categorization: 'single-purpose',
		usage: 'Reserved for representing data products and apps.',
		team: 'Compass',
		status: 'published',
	},
	'data-bucket': {
		keywords: ['data-bucket', 'databucket', 'icon', 'icon-lab', 'data bucketing', 'segmentation'],
		componentName: 'DataBucketIcon',
		package: '@atlaskit/icon-lab/core/data-bucket',
		categorization: 'single-purpose',
		usage: 'Reserved for bucketing data.',
		team: 'Data Experiences',
		status: 'published',
	},
	'data-formula': {
		keywords: ['data-formula', 'dataformula', 'icon', 'icon-lab', 'data formula'],
		componentName: 'DataFormulaIcon',
		package: '@atlaskit/icon-lab/core/data-formula',
		categorization: 'single-purpose',
		usage: 'Reserved for data formulas.',
		team: 'Data experiences',
		status: 'published',
	},
	'data-function': {
		keywords: ['data-function', 'datafunction', 'icon', 'icon-lab', 'data function'],
		componentName: 'DataFunctionIcon',
		package: '@atlaskit/icon-lab/core/data-function',
		categorization: 'single-purpose',
		usage: 'Reserved for data functions.',
		team: 'Data Experiences',
		status: 'published',
	},
	'data-lake': {
		keywords: ['data-lake', 'datalake', 'icon', 'icon-lab', 'data lake', 'datalake'],
		componentName: 'DataLakeIcon',
		package: '@atlaskit/icon-lab/core/data-lake',
		categorization: 'single-purpose',
		usage: 'Reserved for representing Atlassian Data Lake.',
		team: 'Design System Team',
		status: 'published',
	},
	'data-pivot': {
		keywords: ['data-pivot', 'datapivot', 'icon', 'icon-lab', 'data pivot', 'column', 'row'],
		componentName: 'DataPivotIcon',
		package: '@atlaskit/icon-lab/core/data-pivot',
		categorization: 'single-purpose',
		usage: 'Reserved for pivoting data.',
		team: 'Data Experiences',
		status: 'published',
	},
	'data-transpose': {
		keywords: [
			'data-transpose',
			'datatranspose',
			'icon',
			'icon-lab',
			'transposition',
			'transpose',
			'column',
			'row',
			'data',
		],
		componentName: 'DataTransposeIcon',
		package: '@atlaskit/icon-lab/core/data-transpose',
		categorization: 'single-purpose',
		usage: 'Reserved for transposing data.',
		team: 'Data Experiences',
		status: 'published',
	},
	'data-unpivot': {
		keywords: ['data-unpivot', 'dataunpivot', 'icon', 'icon-lab', 'data unpivot', 'column', 'row'],
		componentName: 'DataUnpivotIcon',
		package: '@atlaskit/icon-lab/core/data-unpivot',
		categorization: 'single-purpose',
		usage: 'Reserved for unpivoting data.',
		team: 'Data Experiences',
		status: 'published',
	},
	'data-visualization-heatmap': {
		keywords: [
			'data-visualization-heatmap',
			'datavisualizationheatmap',
			'icon',
			'icon-lab',
			'chart',
			'heatmap',
			'data visualization',
			'data visualisation',
		],
		componentName: 'DataVisualizationHeatmapIcon',
		package: '@atlaskit/icon-lab/core/data-visualization-heatmap',
		categorization: 'single-purpose',
		usage: 'Reserved for representing heatmap data visualizations.',
		team: 'Data Experiences',
		status: 'published',
	},
	'data-visualization-metric': {
		keywords: [
			'data-visualization-metric',
			'datavisualizationmetric',
			'icon',
			'icon-lab',
			'single data indicator',
			'metric card',
			'data visualization',
			'data visualisation',
		],
		componentName: 'DataVisualizationMetricIcon',
		package: '@atlaskit/icon-lab/core/data-visualization-metric',
		categorization: 'single-purpose',
		usage: 'Reserved for single data indicator or metric visualizations.',
		team: 'Data Experiences',
		status: 'published',
	},
	'data-zero-fill': {
		keywords: ['data-zero-fill', 'datazerofill', 'icon', 'icon-lab', 'zero', '0', 'data transform'],
		componentName: 'DataZeroFillIcon',
		package: '@atlaskit/icon-lab/core/data-zero-fill',
		categorization: 'single-purpose',
		usage: 'Reserved for replacing empty data fields with zero.',
		team: 'Data Experiences',
		status: 'published',
	},
	'database-storage': {
		keywords: [
			'database-storage',
			'databasestorage',
			'icon',
			'icon-lab',
			'database',
			'db',
			'storage',
			'sql',
		],
		componentName: 'DatabaseStorageIcon',
		package: '@atlaskit/icon-lab/core/database-storage',
		categorization: 'multi-purpose',
		usage: 'Known uses: SQL database in Developer Console',
		team: 'Ecosystem',
		status: 'published',
		slackChannel: '#forge-sql',
	},
	'database-storage-cache': {
		keywords: [
			'database-storage-cache',
			'databasestoragecache',
			'icon',
			'icon-lab',
			'database',
			'db',
			'storage',
			'sql',
			'cache',
		],
		componentName: 'DatabaseStorageCacheIcon',
		package: '@atlaskit/icon-lab/core/database-storage-cache',
		categorization: 'multi-purpose',
		usage: 'Known uses: Storage cache in Developer Console.',
		team: 'Ecosystem',
		status: 'published',
		slackChannel: '#forge-sql',
	},
	'deployed-service': {
		keywords: [
			'deployed-service',
			'deployedservice',
			'icon',
			'icon-lab',
			'deployed service',
			'deployment',
		],
		componentName: 'DeployedServiceIcon',
		package: '@atlaskit/icon-lab/core/deployed-service',
		categorization: 'single-purpose',
		usage: 'Reserved for representing a deployed software, capability, or application service.',
		team: 'JSM',
		status: 'published',
	},
	'diagram-architecture-map': {
		keywords: [
			'diagram-architecture-map',
			'diagramarchitecturemap',
			'icon',
			'icon-lab',
			'diagram',
			'architecture map',
			'cloud',
		],
		componentName: 'DiagramArchitectureMapIcon',
		package: '@atlaskit/icon-lab/core/diagram-architecture-map',
		categorization: 'single-purpose',
		usage: 'Reserved for architecture map diagram type in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-aggregation-left': {
		keywords: [
			'diagram-arrowhead-aggregation-left',
			'diagramarrowheadaggregationleft',
			'icon',
			'icon-lab',
			'arrowhead',
			'aggregation',
			'start point',
			'diagram',
		],
		componentName: 'DiagramArrowheadAggregationLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-aggregation-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing aggregation diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-aggregation-right': {
		keywords: [
			'diagram-arrowhead-aggregation-right',
			'diagramarrowheadaggregationright',
			'icon',
			'icon-lab',
			'arrowhead',
			'aggregation',
			'end point',
			'diagram',
		],
		componentName: 'DiagramArrowheadAggregationRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-aggregation-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing aggregation diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-aggregation-up-right': {
		keywords: [
			'diagram-arrowhead-aggregation-up-right',
			'diagramarrowheadaggregationupright',
			'icon',
			'icon-lab',
			'arrowhead',
			'aggregation',
			'diagonal',
			'diagram',
		],
		componentName: 'DiagramArrowheadAggregationUpRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-aggregation-up-right',
		categorization: 'single-purpose',
		usage: 'Reserved for aggregation diagram in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-association-left': {
		keywords: [
			'diagram-arrowhead-association-left',
			'diagramarrowheadassociationleft',
			'icon',
			'icon-lab',
			'arrowhead',
			'association',
			'start point',
			'diagram',
		],
		componentName: 'DiagramArrowheadAssociationLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-association-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing association diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-association-right': {
		keywords: [
			'diagram-arrowhead-association-right',
			'diagramarrowheadassociationright',
			'icon',
			'icon-lab',
			'arrowhead',
			'association',
			'end point',
			'diagram',
		],
		componentName: 'DiagramArrowheadAssociationRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-association-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing association diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-association-up-right': {
		keywords: [
			'diagram-arrowhead-association-up-right',
			'diagramarrowheadassociationupright',
			'icon',
			'icon-lab',
			'arrowhead',
			'association',
			'diagonal',
			'diagram',
		],
		componentName: 'DiagramArrowheadAssociationUpRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-association-up-right',
		categorization: 'single-purpose',
		usage: 'Reserved for association diagram in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-circle-left': {
		keywords: [
			'diagram-arrowhead-circle-left',
			'diagramarrowheadcircleleft',
			'icon',
			'icon-lab',
			'arrowhead',
			'circle',
			'start point',
			'diagram',
		],
		componentName: 'DiagramArrowheadCircleLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-circle-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing circle diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-circle-right': {
		keywords: [
			'diagram-arrowhead-circle-right',
			'diagramarrowheadcircleright',
			'icon',
			'icon-lab',
			'arrowhead',
			'circle',
			'diagram',
			'end point',
		],
		componentName: 'DiagramArrowheadCircleRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-circle-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing circle diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-circle-up-right': {
		keywords: [
			'diagram-arrowhead-circle-up-right',
			'diagramarrowheadcircleupright',
			'icon',
			'icon-lab',
			'arrowhead',
			'circle',
			'diagram',
		],
		componentName: 'DiagramArrowheadCircleUpRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-circle-up-right',
		categorization: 'single-purpose',
		usage: 'Reserved for circle diagram in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-composition-left': {
		keywords: [
			'diagram-arrowhead-composition-left',
			'diagramarrowheadcompositionleft',
			'icon',
			'icon-lab',
			'arrowhead',
			'composition',
			'start point',
			'diagram',
		],
		componentName: 'DiagramArrowheadCompositionLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-composition-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing composition diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-composition-right': {
		keywords: [
			'diagram-arrowhead-composition-right',
			'diagramarrowheadcompositionright',
			'icon',
			'icon-lab',
			'arrowhead',
			'composition',
			'end point',
			'diagram',
		],
		componentName: 'DiagramArrowheadCompositionRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-composition-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing composition diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-composition-up-right': {
		keywords: [
			'diagram-arrowhead-composition-up-right',
			'diagramarrowheadcompositionupright',
			'icon',
			'icon-lab',
			'arrowhead',
			'composition',
			'diagram',
		],
		componentName: 'DiagramArrowheadCompositionUpRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-composition-up-right',
		categorization: 'single-purpose',
		usage: 'Reserved for composition diagram in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-default-flow-left': {
		keywords: [
			'diagram-arrowhead-default-flow-left',
			'diagramarrowheaddefaultflowleft',
			'icon',
			'icon-lab',
			'arrowhead',
			'default flow',
			'start point',
			'diagram',
		],
		componentName: 'DiagramArrowheadDefaultFlowLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-default-flow-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing default flow diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-default-flow-right': {
		keywords: [
			'diagram-arrowhead-default-flow-right',
			'diagramarrowheaddefaultflowright',
			'icon',
			'icon-lab',
			'arrowhead',
			'default flow',
			'end point',
			'diagram',
		],
		componentName: 'DiagramArrowheadDefaultFlowRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-default-flow-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing default flow diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-default-flow-up-right': {
		keywords: [
			'diagram-arrowhead-default-flow-up-right',
			'diagramarrowheaddefaultflowupright',
			'icon',
			'icon-lab',
			'arrowhead',
			'default flow',
			'diagram',
		],
		componentName: 'DiagramArrowheadDefaultFlowUpRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-default-flow-up-right',
		categorization: 'single-purpose',
		usage: 'Reserved for default flow diagram in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-inheritance-left': {
		keywords: [
			'diagram-arrowhead-inheritance-left',
			'diagramarrowheadinheritanceleft',
			'icon',
			'icon-lab',
			'arrowhead',
			'inheritance',
			'start point',
			'diagram',
		],
		componentName: 'DiagramArrowheadInheritanceLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-inheritance-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing inheritance diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-inheritance-right': {
		keywords: [
			'diagram-arrowhead-inheritance-right',
			'diagramarrowheadinheritanceright',
			'icon',
			'icon-lab',
			'arrowhead',
			'inheritance',
			'end point',
			'diagram',
		],
		componentName: 'DiagramArrowheadInheritanceRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-inheritance-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing inheritance diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-inheritance-up-right': {
		keywords: [
			'diagram-arrowhead-inheritance-up-right',
			'diagramarrowheadinheritanceupright',
			'icon',
			'icon-lab',
			'arrowhead',
			'inheritance',
			'diagram',
		],
		componentName: 'DiagramArrowheadInheritanceUpRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-inheritance-up-right',
		categorization: 'single-purpose',
		usage: 'Reserved for inheritance diagram in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-many-left': {
		keywords: [
			'diagram-arrowhead-many-left',
			'diagramarrowheadmanyleft',
			'icon',
			'icon-lab',
			'arrowhead',
			'many',
			'start point',
			'diagram',
		],
		componentName: 'DiagramArrowheadManyLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-many-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing many diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-many-right': {
		keywords: [
			'diagram-arrowhead-many-right',
			'diagramarrowheadmanyright',
			'icon',
			'icon-lab',
			'arrowhead',
			'many',
			'end point',
			'diagram',
		],
		componentName: 'DiagramArrowheadManyRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-many-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing many diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-many-up-right': {
		keywords: [
			'diagram-arrowhead-many-up-right',
			'diagramarrowheadmanyupright',
			'icon',
			'icon-lab',
			'arrowhead',
			'many',
			'diagram',
		],
		componentName: 'DiagramArrowheadManyUpRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-many-up-right',
		categorization: 'single-purpose',
		usage: 'Reserved for many diagram in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-one-left': {
		keywords: [
			'diagram-arrowhead-one-left',
			'diagramarrowheadoneleft',
			'icon',
			'icon-lab',
			'arrowhead',
			'one',
			'start point',
			'diagram',
		],
		componentName: 'DiagramArrowheadOneLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-one-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing one diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-one-or-many-left': {
		keywords: [
			'diagram-arrowhead-one-or-many-left',
			'diagramarrowheadoneormanyleft',
			'icon',
			'icon-lab',
			'arrowhead',
			'one or many',
			'start point',
			'diagram',
		],
		componentName: 'DiagramArrowheadOneOrManyLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-one-or-many-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing one or many diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-one-or-many-right': {
		keywords: [
			'diagram-arrowhead-one-or-many-right',
			'diagramarrowheadoneormanyright',
			'icon',
			'icon-lab',
			'arrowhead',
			'one or many',
			'end point',
			'diagram',
		],
		componentName: 'DiagramArrowheadOneOrManyRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-one-or-many-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing one or many diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-one-or-many-up-right': {
		keywords: [
			'diagram-arrowhead-one-or-many-up-right',
			'diagramarrowheadoneormanyupright',
			'icon',
			'icon-lab',
			'arrowhead',
			'one or many',
			'diagram',
		],
		componentName: 'DiagramArrowheadOneOrManyUpRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-one-or-many-up-right',
		categorization: 'single-purpose',
		usage: 'Reserved for one or many diagram in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-one-right': {
		keywords: [
			'diagram-arrowhead-one-right',
			'diagramarrowheadoneright',
			'icon',
			'icon-lab',
			'arrowhead',
			'one',
			'end point',
			'diagram',
		],
		componentName: 'DiagramArrowheadOneRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-one-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing one diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-one-up-right': {
		keywords: [
			'diagram-arrowhead-one-up-right',
			'diagramarrowheadoneupright',
			'icon',
			'icon-lab',
			'arrowhead',
			'one',
			'diagram',
		],
		componentName: 'DiagramArrowheadOneUpRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-one-up-right',
		categorization: 'single-purpose',
		usage: 'Reserved for one diagram in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-only-one-left': {
		keywords: [
			'diagram-arrowhead-only-one-left',
			'diagramarrowheadonlyoneleft',
			'icon',
			'icon-lab',
			'arrowhead',
			'only one',
			'start point',
			'diagram',
		],
		componentName: 'DiagramArrowheadOnlyOneLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-only-one-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing only one diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-only-one-right': {
		keywords: [
			'diagram-arrowhead-only-one-right',
			'diagramarrowheadonlyoneright',
			'icon',
			'icon-lab',
			'arrowhead',
			'only one',
			'end point',
			'diagram',
		],
		componentName: 'DiagramArrowheadOnlyOneRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-only-one-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing only one diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-only-one-up-right': {
		keywords: [
			'diagram-arrowhead-only-one-up-right',
			'diagramarrowheadonlyoneupright',
			'icon',
			'icon-lab',
			'arrowhead',
			'only one',
			'diagram',
		],
		componentName: 'DiagramArrowheadOnlyOneUpRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-only-one-up-right',
		categorization: 'single-purpose',
		usage: 'Reserved for only one diagram in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-sequence-left': {
		keywords: [
			'diagram-arrowhead-sequence-left',
			'diagramarrowheadsequenceleft',
			'icon',
			'icon-lab',
			'arrowhead',
			'sequence',
			'start point',
			'diagram',
		],
		componentName: 'DiagramArrowheadSequenceLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-sequence-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing sequence diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-sequence-right': {
		keywords: [
			'diagram-arrowhead-sequence-right',
			'diagramarrowheadsequenceright',
			'icon',
			'icon-lab',
			'arrowhead',
			'sequence',
			'end point',
			'diagram',
		],
		componentName: 'DiagramArrowheadSequenceRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-sequence-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing sequence diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-sequence-up-right': {
		keywords: [
			'diagram-arrowhead-sequence-up-right',
			'diagramarrowheadsequenceupright',
			'icon',
			'icon-lab',
			'arrowhead',
			'sequence',
			'diagram',
		],
		componentName: 'DiagramArrowheadSequenceUpRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-sequence-up-right',
		categorization: 'single-purpose',
		usage: 'Reserved for sequence diagram in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-zero-or-many-left': {
		keywords: [
			'diagram-arrowhead-zero-or-many-left',
			'diagramarrowheadzeroormanyleft',
			'icon',
			'icon-lab',
			'arrowhead',
			'zero or many',
			'start point',
			'diagram',
		],
		componentName: 'DiagramArrowheadZeroOrManyLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-zero-or-many-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing zero or many diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-zero-or-many-right': {
		keywords: [
			'diagram-arrowhead-zero-or-many-right',
			'diagramarrowheadzeroormanyright',
			'icon',
			'icon-lab',
			'arrowhead',
			'zero or many',
			'end point',
			'diagram',
		],
		componentName: 'DiagramArrowheadZeroOrManyRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-zero-or-many-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing zero or many diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-zero-or-many-up-right': {
		keywords: [
			'diagram-arrowhead-zero-or-many-up-right',
			'diagramarrowheadzeroormanyupright',
			'icon',
			'icon-lab',
			'arrowhead',
			'zero or many',
			'diagram',
		],
		componentName: 'DiagramArrowheadZeroOrManyUpRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-zero-or-many-up-right',
		categorization: 'single-purpose',
		usage: 'Reserved for zero or many diagram in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-zero-or-one-left': {
		keywords: [
			'diagram-arrowhead-zero-or-one-left',
			'diagramarrowheadzerooroneleft',
			'icon',
			'icon-lab',
			'arrowhead',
			'zero or one',
			'start point',
			'diagram',
		],
		componentName: 'DiagramArrowheadZeroOrOneLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-zero-or-one-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing zero or one diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-zero-or-one-right': {
		keywords: [
			'diagram-arrowhead-zero-or-one-right',
			'diagramarrowheadzerooroneright',
			'icon',
			'icon-lab',
			'arrowhead',
			'zero or one',
			'end point',
			'diagram',
		],
		componentName: 'DiagramArrowheadZeroOrOneRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-zero-or-one-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing zero or one diagram arrowhead in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-arrowhead-zero-or-one-up-right': {
		keywords: [
			'diagram-arrowhead-zero-or-one-up-right',
			'diagramarrowheadzerooroneupright',
			'icon',
			'icon-lab',
			'arrowhead',
			'zero or one',
			'diagram',
		],
		componentName: 'DiagramArrowheadZeroOrOneUpRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-arrowhead-zero-or-one-up-right',
		categorization: 'single-purpose',
		usage: 'Reserved for zero or one diagram in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-object-boundary': {
		keywords: [
			'diagram-object-boundary',
			'diagramobjectboundary',
			'icon',
			'icon-lab',
			'Diagram',
			'object',
			'boundary',
			'Whiteboards',
		],
		componentName: 'DiagramObjectBoundaryIcon',
		package: '@atlaskit/icon-lab/core/diagram-object-boundary',
		categorization: 'single-purpose',
		usage: 'Reserved for Diagram object boundary in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-object-entity': {
		keywords: [
			'diagram-object-entity',
			'diagramobjectentity',
			'icon',
			'icon-lab',
			'Diagram',
			'Whiteboards',
			'entity',
			'object',
		],
		componentName: 'DiagramObjectEntityIcon',
		package: '@atlaskit/icon-lab/core/diagram-object-entity',
		categorization: 'single-purpose',
		usage: 'Reserved for diagram symbol entity object in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-action': {
		keywords: [
			'diagram-symbol-action',
			'diagramsymbolaction',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'action',
		],
		componentName: 'DiagramSymbolActionIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-action',
		categorization: 'single-purpose',
		usage: 'Reserved for action diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-activation': {
		keywords: [
			'diagram-symbol-activation',
			'diagramsymbolactivation',
			'icon',
			'icon-lab',
			'diagram symbol',
			'UML shape',
			'activation',
		],
		componentName: 'DiagramSymbolActivationIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-activation',
		categorization: 'single-purpose',
		usage: 'Reserved for activation UML diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-actor': {
		keywords: [
			'diagram-symbol-actor',
			'diagramsymbolactor',
			'icon',
			'icon-lab',
			'diagram symbol',
			'actor',
			'person',
			'UML shape',
		],
		componentName: 'DiagramSymbolActorIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-actor',
		categorization: 'single-purpose',
		usage: 'Reserved for actor UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-ad-hoc': {
		keywords: [
			'diagram-symbol-ad-hoc',
			'diagramsymboladhoc',
			'icon',
			'icon-lab',
			'diagram symbol',
			'ad hoc',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolAdHocIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-ad-hoc',
		categorization: 'single-purpose',
		usage: 'Reserved for ad hoc BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-alternate-process': {
		keywords: [
			'diagram-symbol-alternate-process',
			'diagramsymbolalternateprocess',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'alternate process',
		],
		componentName: 'DiagramSymbolAlternateProcessIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-alternate-process',
		categorization: 'single-purpose',
		usage: 'Reserved for alternate process diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-arrow-left': {
		keywords: [
			'diagram-symbol-arrow-left',
			'diagramsymbolarrowleft',
			'icon',
			'icon-lab',
			'diagram symbol',
			'left arrow',
			'start point',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolArrowLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-arrow-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing arrow BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-arrow-left-filled': {
		keywords: [
			'diagram-symbol-arrow-left-filled',
			'diagramsymbolarrowleftfilled',
			'icon',
			'icon-lab',
			'diagram symbol',
			'left arrow',
			'start point',
			'filled',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolArrowLeftFilledIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-arrow-left-filled',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing arrow BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-arrow-right': {
		keywords: [
			'diagram-symbol-arrow-right',
			'diagramsymbolarrowright',
			'icon',
			'icon-lab',
			'diagram symbol',
			'right arrow',
			'end point',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolArrowRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-arrow-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing arrow BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-arrow-right-filled': {
		keywords: [
			'diagram-symbol-arrow-right-filled',
			'diagramsymbolarrowrightfilled',
			'icon',
			'icon-lab',
			'diagram symbol',
			'right arrow',
			'end point',
			'filled',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolArrowRightFilledIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-arrow-right-filled',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing arrow BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-assembly': {
		keywords: [
			'diagram-symbol-assembly',
			'diagramsymbolassembly',
			'icon',
			'icon-lab',
			'diagram symbol',
			'assembly',
			'UML shape',
		],
		componentName: 'DiagramSymbolAssemblyIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-assembly',
		categorization: 'single-purpose',
		usage: 'Reserved for assembly UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-browser': {
		keywords: [
			'diagram-symbol-browser',
			'diagramsymbolbrowser',
			'icon',
			'icon-lab',
			'diagram symbol',
			'web browser',
		],
		componentName: 'DiagramSymbolBrowserIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-browser',
		categorization: 'single-purpose',
		usage: 'Reserved for browser diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-class': {
		keywords: [
			'diagram-symbol-class',
			'diagramsymbolclass',
			'icon',
			'icon-lab',
			'diagram symbol',
			'class',
			'UML shape',
		],
		componentName: 'DiagramSymbolClassIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-class',
		categorization: 'single-purpose',
		usage: 'Reserved for class UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-cloud': {
		keywords: [
			'diagram-symbol-cloud',
			'diagramsymbolcloud',
			'icon',
			'icon-lab',
			'diagram symbol',
			'cloud',
			'advanced shape',
		],
		componentName: 'DiagramSymbolCloudIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-cloud',
		categorization: 'single-purpose',
		usage: 'Reserved for cloud diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-collaboration': {
		keywords: [
			'diagram-symbol-collaboration',
			'diagramsymbolcollaboration',
			'icon',
			'icon-lab',
			'diagram symbol',
			'collaboration',
			'collaborate',
		],
		componentName: 'DiagramSymbolCollaborationIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-collaboration',
		categorization: 'single-purpose',
		usage: 'Reserved for collaboration diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-collate': {
		keywords: [
			'diagram-symbol-collate',
			'diagramsymbolcollate',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'collate',
		],
		componentName: 'DiagramSymbolCollateIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-collate',
		categorization: 'single-purpose',
		usage: 'Reserved for collate diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-comment-left': {
		keywords: [
			'diagram-symbol-comment-left',
			'diagramsymbolcommentleft',
			'icon',
			'icon-lab',
			'comment',
			'left',
			'diagram',
			'symbol',
		],
		componentName: 'DiagramSymbolCommentLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-comment-left',
		categorization: 'single-purpose',
		usage: 'Reserved for comment left diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-comment-right': {
		keywords: [
			'diagram-symbol-comment-right',
			'diagramsymbolcommentright',
			'icon',
			'icon-lab',
			'comment',
			'right',
			'diagram',
			'symbol',
		],
		componentName: 'DiagramSymbolCommentRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-comment-right',
		categorization: 'single-purpose',
		usage: 'Reserved for comment right diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-complex': {
		keywords: [
			'diagram-symbol-complex',
			'diagramsymbolcomplex',
			'icon',
			'icon-lab',
			'diagram symbol',
			'complex',
			'BPMN shape',
			'asterisk',
		],
		componentName: 'DiagramSymbolComplexIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-complex',
		categorization: 'single-purpose',
		usage: 'Reserved for complex BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-component': {
		keywords: [
			'diagram-symbol-component',
			'diagramsymbolcomponent',
			'icon',
			'icon-lab',
			'diagram symbol',
			'component',
			'UML shape',
		],
		componentName: 'DiagramSymbolComponentIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-component',
		categorization: 'single-purpose',
		usage: 'Reserved for component UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-component-box': {
		keywords: [
			'diagram-symbol-component-box',
			'diagramsymbolcomponentbox',
			'icon',
			'icon-lab',
			'diagram symbol',
			'component box',
			'UML shape',
		],
		componentName: 'DiagramSymbolComponentBoxIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-component-box',
		categorization: 'single-purpose',
		usage: 'Reserved for component box UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-compute': {
		keywords: [
			'diagram-symbol-compute',
			'diagramsymbolcompute',
			'icon',
			'icon-lab',
			'diagram symbol',
			'compute',
			'processor',
			'microchip',
			'advanced shape',
		],
		componentName: 'DiagramSymbolComputeIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-compute',
		categorization: 'single-purpose',
		usage: 'Reserved for compute diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-connector-off-page': {
		keywords: [
			'diagram-symbol-connector-off-page',
			'diagramsymbolconnectoroffpage',
			'icon',
			'icon-lab',
			'off-page',
			'diagram',
			'symbol',
			'connector',
		],
		componentName: 'DiagramSymbolConnectorOffPageIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-connector-off-page',
		categorization: 'single-purpose',
		usage: 'Reserved for off-page connector diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-connector-on-page': {
		keywords: [
			'diagram-symbol-connector-on-page',
			'diagramsymbolconnectoronpage',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'on-page',
			'connector',
		],
		componentName: 'DiagramSymbolConnectorOnPageIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-connector-on-page',
		categorization: 'single-purpose',
		usage: 'Reserved for on-page connector diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-container': {
		keywords: [
			'diagram-symbol-container',
			'diagramsymbolcontainer',
			'icon',
			'icon-lab',
			'diagram symbol',
			'container',
		],
		componentName: 'DiagramSymbolContainerIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-container',
		categorization: 'single-purpose',
		usage: 'Reserved for container diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-database': {
		keywords: [
			'diagram-symbol-database',
			'diagramsymboldatabase',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'database',
		],
		componentName: 'DiagramSymbolDatabaseIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-database',
		categorization: 'single-purpose',
		usage: 'Reserved for database diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-database-source': {
		keywords: [
			'diagram-symbol-database-source',
			'diagramsymboldatabasesource',
			'icon',
			'icon-lab',
			'diagram symbol',
			'database',
			'db',
			'source',
			'advanced shape',
		],
		componentName: 'DiagramSymbolDatabaseSourceIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-database-source',
		categorization: 'single-purpose',
		usage: 'Reserved for database source diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-decision': {
		keywords: [
			'diagram-symbol-decision',
			'diagramsymboldecision',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'decision',
		],
		componentName: 'DiagramSymbolDecisionIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-decision',
		categorization: 'single-purpose',
		usage: 'Reserved for decision diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-delay': {
		keywords: [
			'diagram-symbol-delay',
			'diagramsymboldelay',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'delay',
		],
		componentName: 'DiagramSymbolDelayIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-delay',
		categorization: 'single-purpose',
		usage: 'Reserved for delay diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-display': {
		keywords: [
			'diagram-symbol-display',
			'diagramsymboldisplay',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'display',
		],
		componentName: 'DiagramSymbolDisplayIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-display',
		categorization: 'single-purpose',
		usage: 'Reserved for display diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-document': {
		keywords: [
			'diagram-symbol-document',
			'diagramsymboldocument',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'document',
		],
		componentName: 'DiagramSymbolDocumentIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-document',
		categorization: 'single-purpose',
		usage: 'Reserved for single document diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-documents': {
		keywords: [
			'diagram-symbol-documents',
			'diagramsymboldocuments',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'multiple documents',
		],
		componentName: 'DiagramSymbolDocumentsIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-documents',
		categorization: 'single-purpose',
		usage: 'Reserved for multiple documents diagram symbol',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-end': {
		keywords: [
			'diagram-symbol-end',
			'diagramsymbolend',
			'icon',
			'icon-lab',
			'diagram symbol',
			'end',
			'UML shape',
		],
		componentName: 'DiagramSymbolEndIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-end',
		categorization: 'single-purpose',
		usage: 'Reserved for end UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-error': {
		keywords: [
			'diagram-symbol-error',
			'diagramsymbolerror',
			'icon',
			'icon-lab',
			'diagram symbol',
			'error',
			'lightning bolt',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolErrorIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-error',
		categorization: 'single-purpose',
		usage: 'Reserved for error BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-error-filled': {
		keywords: [
			'diagram-symbol-error-filled',
			'diagramsymbolerrorfilled',
			'icon',
			'icon-lab',
			'diagram symbol',
			'error',
			'filled',
			'lightning bolt',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolErrorFilledIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-error-filled',
		categorization: 'single-purpose',
		usage: 'Reserved for error BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-event-based': {
		keywords: [
			'diagram-symbol-event-based',
			'diagramsymboleventbased',
			'icon',
			'icon-lab',
			'diagram symbol',
			'event based',
			'pentagon',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolEventBasedIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-event-based',
		categorization: 'single-purpose',
		usage: 'Reserved for event based BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-event-based-filled': {
		keywords: [
			'diagram-symbol-event-based-filled',
			'diagramsymboleventbasedfilled',
			'icon',
			'icon-lab',
			'diagram symbol',
			'event based',
			'pentagon',
			'filled',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolEventBasedFilledIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-event-based-filled',
		categorization: 'single-purpose',
		usage: 'Reserved for event based BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-exclusive': {
		keywords: [
			'diagram-symbol-exclusive',
			'diagramsymbolexclusive',
			'icon',
			'icon-lab',
			'diagram symbol',
			'exclusive',
			'cross',
			'x',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolExclusiveIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-exclusive',
		categorization: 'single-purpose',
		usage: 'Reserved for exclusive BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-exclusive-filled': {
		keywords: [
			'diagram-symbol-exclusive-filled',
			'diagramsymbolexclusivefilled',
			'icon',
			'icon-lab',
			'diagram symbol',
			'exclusive',
			'filled',
			'cross',
			'x',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolExclusiveFilledIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-exclusive-filled',
		categorization: 'single-purpose',
		usage: 'Reserved for exclusive BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-file': {
		keywords: [
			'diagram-symbol-file',
			'diagramsymbolfile',
			'icon',
			'icon-lab',
			'diagram symbol',
			'file',
			'advanced shape',
			'document',
		],
		componentName: 'DiagramSymbolFileIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-file',
		categorization: 'single-purpose',
		usage: 'Reserved for file diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-fork-horizontal': {
		keywords: [
			'diagram-symbol-fork-horizontal',
			'diagramsymbolforkhorizontal',
			'icon',
			'icon-lab',
			'diagram symbol',
			'horizontal fork',
			'UML shape',
			'filled',
		],
		componentName: 'DiagramSymbolForkHorizontalIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-fork-horizontal',
		categorization: 'single-purpose',
		usage: 'Reserved for horizontal fork UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-fork-vertical': {
		keywords: [
			'diagram-symbol-fork-vertical',
			'diagramsymbolforkvertical',
			'icon',
			'icon-lab',
			'diagram symbol',
			'vertical fork',
			'UML shape',
			'filled',
		],
		componentName: 'DiagramSymbolForkVerticalIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-fork-vertical',
		categorization: 'single-purpose',
		usage: 'Reserved for vertical fork UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-frame': {
		keywords: [
			'diagram-symbol-frame',
			'diagramsymbolframe',
			'icon',
			'icon-lab',
			'diagram symbol',
			'frame',
			'container',
			'section',
		],
		componentName: 'DiagramSymbolFrameIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-frame',
		categorization: 'single-purpose',
		usage: 'Reserved for frame diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-frontend': {
		keywords: [
			'diagram-symbol-frontend',
			'diagramsymbolfrontend',
			'icon',
			'icon-lab',
			'diagram symbol',
			'frontend',
			'advanced shape',
			'<>',
			'angle brackets',
			'code',
		],
		componentName: 'DiagramSymbolFrontendIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-frontend',
		categorization: 'single-purpose',
		usage: 'Reserved for frontend diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-hard-disk': {
		keywords: [
			'diagram-symbol-hard-disk',
			'diagramsymbolharddisk',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'hard disk',
			'hard drive',
			'storage',
		],
		componentName: 'DiagramSymbolHardDiskIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-hard-disk',
		categorization: 'single-purpose',
		usage: 'Reserved for hard disk diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-history': {
		keywords: [
			'diagram-symbol-history',
			'diagramsymbolhistory',
			'icon',
			'icon-lab',
			'diagram symbol',
			'history',
			'UML shape',
		],
		componentName: 'DiagramSymbolHistoryIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-history',
		categorization: 'single-purpose',
		usage: 'Reserved for history UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-input-output': {
		keywords: [
			'diagram-symbol-input-output',
			'diagramsymbolinputoutput',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'input',
			'output',
		],
		componentName: 'DiagramSymbolInputOutputIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-input-output',
		categorization: 'single-purpose',
		usage: 'Reserved for input or output diagram symbols.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-interface-attributes': {
		keywords: [
			'diagram-symbol-interface-attributes',
			'diagramsymbolinterfaceattributes',
			'icon',
			'icon-lab',
			'diagram symbol',
			'UI',
			'interface',
			'attributes',
			'UML shape',
		],
		componentName: 'DiagramSymbolInterfaceAttributesIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-interface-attributes',
		categorization: 'single-purpose',
		usage: 'Reserved for interface attributes UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-internal-storage': {
		keywords: [
			'diagram-symbol-internal-storage',
			'diagramsymbolinternalstorage',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'internal storage',
		],
		componentName: 'DiagramSymbolInternalStorageIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-internal-storage',
		categorization: 'single-purpose',
		usage: 'Reserved for internal storage diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-loop-limit': {
		keywords: [
			'diagram-symbol-loop-limit',
			'diagramsymbollooplimit',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'loop limit',
		],
		componentName: 'DiagramSymbolLoopLimitIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-loop-limit',
		categorization: 'single-purpose',
		usage: 'Reserved for loop limit diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-manual': {
		keywords: [
			'diagram-symbol-manual',
			'diagramsymbolmanual',
			'icon',
			'icon-lab',
			'diagram symbol',
			'manual',
			'hand',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolManualIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-manual',
		categorization: 'single-purpose',
		usage: 'Reserved for manual BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-manual-input': {
		keywords: [
			'diagram-symbol-manual-input',
			'diagramsymbolmanualinput',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'manual input',
		],
		componentName: 'DiagramSymbolManualInputIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-manual-input',
		categorization: 'single-purpose',
		usage: 'Reserved for manual input diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-manual-operation': {
		keywords: [
			'diagram-symbol-manual-operation',
			'diagramsymbolmanualoperation',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'manual operation',
		],
		componentName: 'DiagramSymbolManualOperationIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-manual-operation',
		categorization: 'single-purpose',
		usage: 'Reserved for manual operation diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-merge': {
		keywords: [
			'diagram-symbol-merge',
			'diagramsymbolmerge',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'merge',
			'triangle',
		],
		componentName: 'DiagramSymbolMergeIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-merge',
		categorization: 'single-purpose',
		usage: 'Reserved for merge diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-mind-map': {
		keywords: [
			'diagram-symbol-mind-map',
			'diagramsymbolmindmap',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'mind map',
		],
		componentName: 'DiagramSymbolMindMapIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-mind-map',
		categorization: 'single-purpose',
		usage: 'Reserved for mind map diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-node': {
		keywords: [
			'diagram-symbol-node',
			'diagramsymbolnode',
			'icon',
			'icon-lab',
			'diagram symbol',
			'node',
			'cube',
		],
		componentName: 'DiagramSymbolNodeIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-node',
		categorization: 'single-purpose',
		usage: 'Reserved for node diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-note': {
		keywords: [
			'diagram-symbol-note',
			'diagramsymbolnote',
			'icon',
			'icon-lab',
			'diagram symbol',
			'note',
			'UML shape',
		],
		componentName: 'DiagramSymbolNoteIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-note',
		categorization: 'single-purpose',
		usage: 'Reserved for note UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-or': {
		keywords: [
			'diagram-symbol-or',
			'diagramsymbolor',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'or',
			'logic',
		],
		componentName: 'DiagramSymbolOrIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-or',
		categorization: 'single-purpose',
		usage: 'Reserved for or diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-package': {
		keywords: [
			'diagram-symbol-package',
			'diagramsymbolpackage',
			'icon',
			'icon-lab',
			'diagram symbol',
			'container',
			'package',
		],
		componentName: 'DiagramSymbolPackageIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-package',
		categorization: 'single-purpose',
		usage: 'Reserved for package diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-parallel-even-based': {
		keywords: [
			'diagram-symbol-parallel-even-based',
			'diagramsymbolparallelevenbased',
			'icon',
			'icon-lab',
			'diagram symbol',
			'plus',
			'parallel even based',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolParallelEvenBasedIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-parallel-even-based',
		categorization: 'single-purpose',
		usage: 'Reserved for parallel even based BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-parallel-even-based-filled': {
		keywords: [
			'diagram-symbol-parallel-even-based-filled',
			'diagramsymbolparallelevenbasedfilled',
			'icon',
			'icon-lab',
			'diagram symbol',
			'plus',
			'filled',
			'parallel even based',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolParallelEvenBasedFilledIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-parallel-even-based-filled',
		categorization: 'single-purpose',
		usage: 'Reserved for parallel even based BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-parallel-mi': {
		keywords: [
			'diagram-symbol-parallel-mi',
			'diagramsymbolparallelmi',
			'icon',
			'icon-lab',
			'diagram symbol',
			'parallel mi',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolParallelMiIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-parallel-mi',
		categorization: 'single-purpose',
		usage: 'Reserved for parallel mi BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-pin-left': {
		keywords: [
			'diagram-symbol-pin-left',
			'diagramsymbolpinleft',
			'icon',
			'icon-lab',
			'diagram symbol',
			'arrow left',
			'pin',
			'UML shape',
		],
		componentName: 'DiagramSymbolPinLeftIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-pin-left',
		categorization: 'single-purpose',
		usage: 'Reserved for left-facing pin UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-pin-left-filled': {
		keywords: [
			'diagram-symbol-pin-left-filled',
			'diagramsymbolpinleftfilled',
			'icon',
			'icon-lab',
			'diagram symbol',
			'left arrow',
			'filled',
			'pin',
			'UML shape',
		],
		componentName: 'DiagramSymbolPinLeftFilledIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-pin-left-filled',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing pin UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-pin-right': {
		keywords: [
			'diagram-symbol-pin-right',
			'diagramsymbolpinright',
			'icon',
			'icon-lab',
			'diagram symbol',
			'right arrow',
			'pin',
			'UML shape',
		],
		componentName: 'DiagramSymbolPinRightIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-pin-right',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing pin UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-pin-right-filled': {
		keywords: [
			'diagram-symbol-pin-right-filled',
			'diagramsymbolpinrightfilled',
			'icon',
			'icon-lab',
			'diagram symbol',
			'right arrow',
			'filled',
			'pin',
			'UML shape',
		],
		componentName: 'DiagramSymbolPinRightFilledIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-pin-right-filled',
		categorization: 'single-purpose',
		usage: 'Reserved for right-facing pin UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-pool-horizontal': {
		keywords: [
			'diagram-symbol-pool-horizontal',
			'diagramsymbolpoolhorizontal',
			'icon',
			'icon-lab',
			'diagram symbol',
			'horizontal pool',
			'container',
		],
		componentName: 'DiagramSymbolPoolHorizontalIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-pool-horizontal',
		categorization: 'single-purpose',
		usage: 'Reserved for horizontal pool diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-pool-vertical': {
		keywords: [
			'diagram-symbol-pool-vertical',
			'diagramsymbolpoolvertical',
			'icon',
			'icon-lab',
			'diagram symbol',
			'vertical pool',
			'container',
		],
		componentName: 'DiagramSymbolPoolVerticalIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-pool-vertical',
		categorization: 'single-purpose',
		usage: 'Reserved for vertical pool diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-predefined-process': {
		keywords: [
			'diagram-symbol-predefined-process',
			'diagramsymbolpredefinedprocess',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'predefined process',
		],
		componentName: 'DiagramSymbolPredefinedProcessIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-predefined-process',
		categorization: 'single-purpose',
		usage: 'Reserved for predefined process diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-preparation': {
		keywords: [
			'diagram-symbol-preparation',
			'diagramsymbolpreparation',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'preparation',
		],
		componentName: 'DiagramSymbolPreparationIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-preparation',
		categorization: 'single-purpose',
		usage: 'Reserved for preparation diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-provided-interface': {
		keywords: [
			'diagram-symbol-provided-interface',
			'diagramsymbolprovidedinterface',
			'icon',
			'icon-lab',
			'diagram symbol',
			'provided interface',
			'UML shape',
		],
		componentName: 'DiagramSymbolProvidedInterfaceIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-provided-interface',
		categorization: 'single-purpose',
		usage: 'Reserved for provided interface UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-receive-signal': {
		keywords: [
			'diagram-symbol-receive-signal',
			'diagramsymbolreceivesignal',
			'icon',
			'icon-lab',
			'diagram symbol',
			'receive signal',
			'UML shape',
		],
		componentName: 'DiagramSymbolReceiveSignalIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-receive-signal',
		categorization: 'single-purpose',
		usage: 'Reserved for receive signal UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-required-interface': {
		keywords: [
			'diagram-symbol-required-interface',
			'diagramsymbolrequiredinterface',
			'icon',
			'icon-lab',
			'diagram symbol',
			'required interface',
			'UML shape',
		],
		componentName: 'DiagramSymbolRequiredInterfaceIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-required-interface',
		categorization: 'single-purpose',
		usage: 'Reserved for required interface UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-send': {
		keywords: [
			'diagram-symbol-send',
			'diagramsymbolsend',
			'icon',
			'icon-lab',
			'diagram symbol',
			'send',
			'envelope',
			'email',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolSendIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-send',
		categorization: 'single-purpose',
		usage: 'Reserved for send BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-send-signal': {
		keywords: [
			'diagram-symbol-send-signal',
			'diagramsymbolsendsignal',
			'icon',
			'icon-lab',
			'diagram symbol',
			'send signal',
			'UML shape',
		],
		componentName: 'DiagramSymbolSendSignalIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-send-signal',
		categorization: 'single-purpose',
		usage: 'Reserved for send signal UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-shield': {
		keywords: [
			'diagram-symbol-shield',
			'diagramsymbolshield',
			'icon',
			'icon-lab',
			'diagram symbol',
			'shield',
			'checkmark',
			'advanced shape',
		],
		componentName: 'DiagramSymbolShieldIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-shield',
		categorization: 'single-purpose',
		usage: 'Reserved for shield diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-signal': {
		keywords: [
			'diagram-symbol-signal',
			'diagramsymbolsignal',
			'icon',
			'icon-lab',
			'diagram symbol',
			'signal',
			'triangle',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolSignalIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-signal',
		categorization: 'single-purpose',
		usage: 'Reserved for signal BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-signal-filled': {
		keywords: [
			'diagram-symbol-signal-filled',
			'diagramsymbolsignalfilled',
			'icon',
			'icon-lab',
			'diagram symbol',
			'signal',
			'filled',
			'triangle',
			'BPMN shape',
		],
		componentName: 'DiagramSymbolSignalFilledIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-signal-filled',
		categorization: 'single-purpose',
		usage: 'Reserved for signal BPMN diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-sort': {
		keywords: [
			'diagram-symbol-sort',
			'diagramsymbolsort',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'sort',
		],
		componentName: 'DiagramSymbolSortIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-sort',
		categorization: 'single-purpose',
		usage: 'Reserved for sort diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-start': {
		keywords: [
			'diagram-symbol-start',
			'diagramsymbolstart',
			'icon',
			'icon-lab',
			'diagram symbol',
			'start',
			'circle',
			'UML shape',
		],
		componentName: 'DiagramSymbolStartIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-start',
		categorization: 'single-purpose',
		usage: 'Reserved for start UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-stored-data': {
		keywords: [
			'diagram-symbol-stored-data',
			'diagramsymbolstoreddata',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'stored data',
		],
		componentName: 'DiagramSymbolStoredDataIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-stored-data',
		categorization: 'single-purpose',
		usage: 'Reserved for stored data diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-summing-junction': {
		keywords: [
			'diagram-symbol-summing-junction',
			'diagramsymbolsummingjunction',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'summing junction',
			'cross',
		],
		componentName: 'DiagramSymbolSummingJunctionIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-summing-junction',
		categorization: 'single-purpose',
		usage: 'Reserved for summing junction diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-swimlanes-horizontal': {
		keywords: [
			'diagram-symbol-swimlanes-horizontal',
			'diagramsymbolswimlaneshorizontal',
			'icon',
			'icon-lab',
			'diagram symbol',
			'horizontal swimlanes',
			'container',
		],
		componentName: 'DiagramSymbolSwimlanesHorizontalIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-swimlanes-horizontal',
		categorization: 'single-purpose',
		usage: 'Reserved for horizontal swimlanes diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-swimlanes-vertical': {
		keywords: [
			'diagram-symbol-swimlanes-vertical',
			'diagramsymbolswimlanesvertical',
			'icon',
			'icon-lab',
			'diagram symbol',
			'vertical swimlanes',
			'columns',
			'container',
		],
		componentName: 'DiagramSymbolSwimlanesVerticalIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-swimlanes-vertical',
		categorization: 'single-purpose',
		usage: 'Reserved for vertical swimlanes diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-switch': {
		keywords: [
			'diagram-symbol-switch',
			'diagramsymbolswitch',
			'icon',
			'icon-lab',
			'diagram symbol',
			'switch',
			'ethernet',
			'advanced shape',
			'network',
		],
		componentName: 'DiagramSymbolSwitchIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-switch',
		categorization: 'single-purpose',
		usage: 'Reserved for switch diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-template': {
		keywords: [
			'diagram-symbol-template',
			'diagramsymboltemplate',
			'icon',
			'icon-lab',
			'diagram symbol',
			'template',
			'UML shape',
			'dashed',
		],
		componentName: 'DiagramSymbolTemplateIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-template',
		categorization: 'single-purpose',
		usage: 'Reserved for template UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-terminator': {
		keywords: [
			'diagram-symbol-terminator',
			'diagramsymbolterminator',
			'icon',
			'icon-lab',
			'diagram',
			'symbol',
			'terminator',
			'terminal',
			'start point',
			'end point',
		],
		componentName: 'DiagramSymbolTerminatorIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-terminator',
		categorization: 'single-purpose',
		usage: 'Reserved for terminator (start or end point) diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'diagram-symbol-use-case': {
		keywords: [
			'diagram-symbol-use-case',
			'diagramsymbolusecase',
			'icon',
			'icon-lab',
			'diagram symbol',
			'use case',
			'oval',
			'UML shape',
		],
		componentName: 'DiagramSymbolUseCaseIcon',
		package: '@atlaskit/icon-lab/core/diagram-symbol-use-case',
		categorization: 'single-purpose',
		usage: 'Reserved for use case UML diagram symbol in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	directory: {
		keywords: ['directory', 'icon', 'icon-lab', 'directory', 'address book'],
		componentName: 'DirectoryIcon',
		package: '@atlaskit/icon-lab/core/directory',
		categorization: 'single-purpose',
		usage: 'Reserved for directory experiences.',
		team: 'Admin Hub',
		status: 'published',
	},
	'distribute-spacing-horizontal': {
		keywords: [
			'distribute-spacing-horizontal',
			'distributespacinghorizontal',
			'icon',
			'icon-lab',
			'Distribute',
			'Horizontal spacing',
			'Tidy up',
			'Clean up',
		],
		componentName: 'DistributeSpacingHorizontalIcon',
		package: '@atlaskit/icon-lab/core/distribute-spacing-horizontal',
		categorization: 'single-purpose',
		usage:
			'Evenly distributing the horizontal space between multiple selected objects on Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'distribute-spacing-vertical': {
		keywords: [
			'distribute-spacing-vertical',
			'distributespacingvertical',
			'icon',
			'icon-lab',
			'Distribute',
			'Vertical spacing',
			'Clean up',
			'Tidy',
		],
		componentName: 'DistributeSpacingVerticalIcon',
		package: '@atlaskit/icon-lab/core/distribute-spacing-vertical',
		categorization: 'single-purpose',
		usage:
			'Evenly distributing the vertical space between multiple selected objects on Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'divider-element': {
		keywords: [
			'divider-element',
			'dividerelement',
			'icon',
			'icon-lab',
			'divider',
			'line break',
			'horizontal rule',
		],
		componentName: 'DividerElementIcon',
		package: '@atlaskit/icon-lab/core/divider-element',
		categorization: 'single-purpose',
		usage: 'Reserved for inserting divider elements in Confluence',
		team: 'editor-design',
		status: 'published',
		slackChannel: '#editor-controls-project',
	},
	'dock-toolbar-bottom': {
		keywords: [
			'dock-toolbar-bottom',
			'docktoolbarbottom',
			'icon',
			'icon-lab',
			'dock to bottom',
			'fix to bottom',
			'pin to bottom',
		],
		componentName: 'DockToolbarBottomIcon',
		package: '@atlaskit/icon-lab/core/dock-toolbar-bottom',
		categorization: 'single-purpose',
		usage: 'Reserved for docking a toolbar to the bottom of a page.',
		team: 'Editor design',
		status: 'published',
	},
	'dock-toolbar-top': {
		keywords: [
			'dock-toolbar-top',
			'docktoolbartop',
			'icon',
			'icon-lab',
			'dock to top',
			'fix to top',
			'pin to top',
		],
		componentName: 'DockToolbarTopIcon',
		package: '@atlaskit/icon-lab/core/dock-toolbar-top',
		categorization: 'single-purpose',
		usage: 'Reserved for docking a toolbar to the top of a page',
		team: 'Editor-design',
		status: 'published',
		slackChannel: '#Editor-design',
	},
	'dock-window-bottom-left': {
		keywords: [
			'dock-window-bottom-left',
			'dockwindowbottomleft',
			'icon',
			'icon-lab',
			'dock to bottom left',
			'fix to bottom left',
			'pin to bottom left',
		],
		componentName: 'DockWindowBottomLeftIcon',
		package: '@atlaskit/icon-lab/core/dock-window-bottom-left',
		categorization: 'single-purpose',
		usage: 'Reserved for docking a modal or window to the bottom left of a page',
		team: 'Editor design',
		status: 'published',
	},
	'dock-window-bottom-right': {
		keywords: [
			'dock-window-bottom-right',
			'dockwindowbottomright',
			'icon',
			'icon-lab',
			'dock to bottom right',
			'fix to bottom right',
			'pin to bottom right',
		],
		componentName: 'DockWindowBottomRightIcon',
		package: '@atlaskit/icon-lab/core/dock-window-bottom-right',
		categorization: 'single-purpose',
		usage: 'Reserved for docking a modal or window to the bottom right of a page',
		team: 'Editor design',
		status: 'published',
	},
	draw: {
		keywords: ['draw', 'icon', 'icon-lab', 'pencil', 'drawing', 'annotate'],
		componentName: 'DrawIcon',
		package: '@atlaskit/icon-lab/core/draw',
		categorization: 'multi-purpose',
		usage: 'For drawing and annotation',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'drop-shadow': {
		keywords: ['drop-shadow', 'dropshadow', 'icon', 'icon-lab', 'Drop shadow'],
		componentName: 'DropShadowIcon',
		package: '@atlaskit/icon-lab/core/drop-shadow',
		categorization: 'single-purpose',
		usage: 'Toggle drop shadow on and off',
		team: 'Whiteboards',
		status: 'published',
	},
	duplicate: {
		keywords: ['duplicate', 'icon', 'icon-lab', 'clone', 'duplicate', 'plus'],
		componentName: 'DuplicateIcon',
		package: '@atlaskit/icon-lab/core/duplicate',
		categorization: 'single-purpose',
		usage: 'Reserved for cloning and duplicating objects.',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	editions: {
		keywords: [
			'editions',
			'icon',
			'icon-lab',
			'gem',
			'premium',
			'diamond',
			'precious stone',
			'editions',
		],
		componentName: 'EditionsIcon',
		package: '@atlaskit/icon-lab/core/editions',
		categorization: 'single-purpose',
		usage:
			'Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.',
		team: 'Design System Team',
		status: 'published',
	},
	'emoji-sad': {
		keywords: [
			'emoji-sad',
			'emojisad',
			'icon',
			'icon-lab',
			'emoji-sad',
			'emojisad',
			'sad-emoji',
			'sad',
			'negative',
		],
		componentName: 'EmojiSadIcon',
		package: '@atlaskit/icon-lab/core/emoji-sad',
		categorization: 'single-purpose',
		usage: 'Reserved for presenting a sad tone or negative sentiment.',
		team: 'Jira Service Management',
		status: 'published',
		slackChannel: '#jsm-phoenix',
	},
	'expand-element': {
		keywords: ['expand-element', 'expandelement', 'icon', 'icon-lab', 'expand', 'editor object'],
		componentName: 'ExpandElementIcon',
		package: '@atlaskit/icon-lab/core/expand-element',
		categorization: 'single-purpose',
		usage: 'Reserved for inserting expand elements in Confluence',
		team: 'editor-design',
		status: 'published',
		slackChannel: '#editor-controls-project',
	},
	eyedropper: {
		keywords: [
			'eyedropper',
			'icon',
			'icon-lab',
			'eyedropper',
			'pipette',
			'color picker',
			'color sample',
		],
		componentName: 'EyedropperIcon',
		package: '@atlaskit/icon-lab/core/eyedropper',
		categorization: 'multi-purpose',
		usage: 'Sampling a color with a color picker',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'field-select': {
		keywords: [
			'field-select',
			'fieldselect',
			'icon',
			'icon-lab',
			'dropdown',
			'single-select',
			'multi-select',
			'select field type',
		],
		componentName: 'FieldSelectIcon',
		package: '@atlaskit/icon-lab/core/field-select',
		categorization: 'single-purpose',
		usage: 'Reserved for representing single and multi-option select field types.',
		team: 'Strategy Collection',
		status: 'published',
	},
	'field-text': {
		keywords: [
			'field-text',
			'fieldtext',
			'icon',
			'icon-lab',
			'form',
			'input',
			'label',
			'cursor',
			'text field',
		],
		componentName: 'FieldTextIcon',
		package: '@atlaskit/icon-lab/core/field-text',
		categorization: 'multi-purpose',
		usage: 'Multi purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'file-markdown': {
		keywords: [
			'file-markdown',
			'filemarkdown',
			'icon',
			'icon-lab',
			'md',
			'markdown',
			'document',
			'file',
			'paper',
		],
		componentName: 'FileMarkdownIcon',
		package: '@atlaskit/icon-lab/core/file-markdown',
		categorization: 'single-purpose',
		usage: 'Reserved for representing a Markdown document filetype.',
		team: 'Confluence',
		status: 'published',
	},
	'file-text': {
		keywords: ['file-text', 'filetext', 'icon', 'icon-lab', 'text file', 'text document', 'paper'],
		componentName: 'FileTextIcon',
		package: '@atlaskit/icon-lab/core/file-text',
		categorization: 'single-purpose',
		usage: 'Reserved for representing an agnostic text document filetype.',
		team: 'Design System Team',
		status: 'published',
	},
	fire: {
		keywords: ['fire', 'icon', 'icon-lab', 'fire', 'flame'],
		componentName: 'FireIcon',
		package: '@atlaskit/icon-lab/core/fire',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'fire-alarm': {
		keywords: ['fire-alarm', 'firealarm', 'icon', 'icon-lab', 'fire alarm', 'alert', 'klaxon'],
		componentName: 'FireAlarmIcon',
		package: '@atlaskit/icon-lab/core/fire-alarm',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	flower: {
		keywords: ['flower', 'icon', 'icon-lab', 'flower', 'daisy', 'growth', 'plant'],
		componentName: 'FlowerIcon',
		package: '@atlaskit/icon-lab/core/flower',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'folder-add': {
		keywords: ['folder-add', 'folderadd', 'icon', 'icon-lab'],
		componentName: 'FolderAddIcon',
		package: '@atlaskit/icon-lab/core/folder-add',
		categorization: 'multi-purpose',
		team: 'Rovo Chat',
		status: 'published',
	},
	'folder-shared': {
		keywords: ['folder-shared', 'foldershared', 'icon', 'icon-lab', 'Shared', 'User', 'Public'],
		componentName: 'FolderSharedIcon',
		package: '@atlaskit/icon-lab/core/folder-shared',
		categorization: 'single-purpose',
		usage: 'Reserved for shared folders',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'generative-date': {
		keywords: [
			'generative-date',
			'generativedate',
			'icon',
			'icon-lab',
			'calendar',
			'suggested date',
		],
		componentName: 'GenerativeDateIcon',
		package: '@atlaskit/icon-lab/core/generative-date',
		categorization: 'single-purpose',
		usage: 'Reserved for suggested dates.',
		team: 'Jira Align',
		status: 'published',
	},
	'generative-indicator': {
		keywords: [
			'generative-indicator',
			'generativeindicator',
			'icon',
			'icon-lab',
			'AI',
			'suggested',
			'generative',
			'suggestion',
		],
		componentName: 'GenerativeIndicatorIcon',
		package: '@atlaskit/icon-lab/core/generative-indicator',
		categorization: 'single-purpose',
		usage: 'Reserved for indicating generative and suggested content.',
		team: 'Jira Align',
		status: 'published',
	},
	gift: {
		keywords: ['gift', 'icon', 'icon-lab', 'gift', 'present'],
		componentName: 'GiftIcon',
		package: '@atlaskit/icon-lab/core/gift',
		categorization: 'multi-purpose',
		usage: 'User-selectable icon choice for calendars',
		team: 'Growth Buy',
		status: 'published',
	},
	'globe-strikethrough': {
		keywords: [
			'globe-strikethrough',
			'globestrikethrough',
			'icon',
			'icon-lab',
			'globe',
			'strikethrough',
			'private',
			'not public',
		],
		componentName: 'GlobeStrikethroughIcon',
		package: '@atlaskit/icon-lab/core/globe-strikethrough',
		categorization: 'multi-purpose',
		usage: 'Known uses: Limited share permissions which are not public',
		team: 'Loom',
		status: 'published',
	},
	group: {
		keywords: ['group', 'icon', 'icon-lab', 'group', 'grouping', 'stack', 'related data'],
		componentName: 'GroupIcon',
		package: '@atlaskit/icon-lab/core/group',
		categorization: 'single-purpose',
		usage: 'Reserved for grouping data',
		team: 'Database',
		status: 'published',
	},
	'group-selection': {
		keywords: [
			'group-selection',
			'groupselection',
			'icon',
			'icon-lab',
			'group',
			'selection',
			'layers',
		],
		componentName: 'GroupSelectionIcon',
		package: '@atlaskit/icon-lab/core/group-selection',
		categorization: 'multi-purpose',
		usage: 'Grouping selected objects in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'group-ungroup-selection': {
		keywords: [
			'group-ungroup-selection',
			'groupungroupselection',
			'icon',
			'icon-lab',
			'ungroup',
			'selection',
			'layers',
		],
		componentName: 'GroupUngroupSelectionIcon',
		package: '@atlaskit/icon-lab/core/group-ungroup-selection',
		categorization: 'multi-purpose',
		usage: 'Ungrouping selected objects in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'hand-closed': {
		keywords: [
			'hand-closed',
			'handclosed',
			'icon',
			'icon-lab',
			'hand tool',
			'closed hand',
			'grab',
			'moving',
		],
		componentName: 'HandClosedIcon',
		package: '@atlaskit/icon-lab/core/hand-closed',
		categorization: 'multi-purpose',
		usage: 'Known uses: Hand tool in Whiteboards when actively moving objects.',
		team: 'Whiteboards',
		status: 'published',
	},
	'hand-open': {
		keywords: ['hand-open', 'handopen', 'icon', 'icon-lab', 'hand tool', 'open hand', 'move tool'],
		componentName: 'HandOpenIcon',
		package: '@atlaskit/icon-lab/core/hand-open',
		categorization: 'multi-purpose',
		usage: 'Known uses: Hand tool in Whiteboards for moving objects.',
		team: 'Whiteboards',
		status: 'published',
	},
	'hand-raised': {
		keywords: ['hand-raised', 'handraised', 'icon', 'icon-lab', 'hand', 'farewell', 'wave'],
		componentName: 'HandRaisedIcon',
		package: '@atlaskit/icon-lab/core/hand-raised',
		categorization: 'multi-purpose',
		usage: 'Used for farewell feed in Atlassian Home.',
		team: 'Whiteboards',
		status: 'published',
	},
	'hardware-audit': {
		keywords: [
			'hardware-audit',
			'hardwareaudit',
			'icon',
			'icon-lab',
			'screen',
			'display',
			'hardware',
			'audit',
			'audited',
			'checklist',
		],
		componentName: 'HardwareAuditIcon',
		package: '@atlaskit/icon-lab/core/hardware-audit',
		categorization: 'single-purpose',
		usage: 'Reserved for representing audited hardware.',
		team: 'JSM',
		status: 'published',
	},
	'hardware-configuration': {
		keywords: [
			'hardware-configuration',
			'hardwareconfiguration',
			'icon',
			'icon-lab',
			'screen',
			'display',
			'hardware',
			'configuration',
			'settings',
			'cog',
		],
		componentName: 'HardwareConfigurationIcon',
		package: '@atlaskit/icon-lab/core/hardware-configuration',
		categorization: 'single-purpose',
		usage: 'Reserved for representing hardware configuration.',
		team: 'JSM',
		status: 'published',
	},
	'hardware-defect': {
		keywords: [
			'hardware-defect',
			'hardwaredefect',
			'icon',
			'icon-lab',
			'screen',
			'display',
			'hardware',
			'damaged',
			'defective',
			'broken',
		],
		componentName: 'HardwareDefectIcon',
		package: '@atlaskit/icon-lab/core/hardware-defect',
		categorization: 'single-purpose',
		usage: 'Reserved for representing defective or damaged hardware.',
		team: 'JSM',
		status: 'published',
	},
	'hardware-dispose': {
		keywords: [
			'hardware-dispose',
			'hardwaredispose',
			'icon',
			'icon-lab',
			'screen',
			'display',
			'hardware',
			'dispose',
			'disposal',
			'end of life',
			'cross',
		],
		componentName: 'HardwareDisposeIcon',
		package: '@atlaskit/icon-lab/core/hardware-dispose',
		categorization: 'single-purpose',
		usage: 'Reserved for representing disposed hardware.',
		team: 'JSM',
		status: 'published',
	},
	'hardware-fulfil': {
		keywords: [
			'hardware-fulfil',
			'hardwarefulfil',
			'icon',
			'icon-lab',
			'screen',
			'display',
			'hardware',
			'fulfil',
			'fulfill',
			'fulfilment',
			'fulfillment',
			'check mark',
		],
		componentName: 'HardwareFulfilIcon',
		package: '@atlaskit/icon-lab/core/hardware-fulfil',
		categorization: 'single-purpose',
		usage: 'Reserved for representing hardware fulfilment',
		team: 'JSM',
		status: 'published',
	},
	'hardware-new': {
		keywords: [
			'hardware-new',
			'hardwarenew',
			'icon',
			'icon-lab',
			'screen',
			'display',
			'hardware',
			'add',
			'new',
			'plus',
		],
		componentName: 'HardwareNewIcon',
		package: '@atlaskit/icon-lab/core/hardware-new',
		categorization: 'single-purpose',
		usage: 'Reserved for representing new hardware.',
		team: 'JSM',
		status: 'published',
	},
	'hardware-procure': {
		keywords: [
			'hardware-procure',
			'hardwareprocure',
			'icon',
			'icon-lab',
			'screen',
			'display',
			'hardware',
			'procure',
			'procurement',
			'purchase',
			'currency',
			'dollar',
			'buy',
			'bought',
		],
		componentName: 'HardwareProcureIcon',
		package: '@atlaskit/icon-lab/core/hardware-procure',
		categorization: 'single-purpose',
		usage: 'Reserved for representing procured hardware.',
		team: 'JSM',
		status: 'published',
	},
	'hardware-refresh': {
		keywords: [
			'hardware-refresh',
			'hardwarerefresh',
			'icon',
			'icon-lab',
			'screen',
			'display',
			'hardware',
			'refresh',
		],
		componentName: 'HardwareRefreshIcon',
		package: '@atlaskit/icon-lab/core/hardware-refresh',
		categorization: 'single-purpose',
		usage: 'Reserved for representing refreshed hardware.',
		team: 'JSM',
		status: 'published',
	},
	'hardware-repair': {
		keywords: [
			'hardware-repair',
			'hardwarerepair',
			'icon',
			'icon-lab',
			'screen',
			'display',
			'hardware',
			'repair',
			'fix',
			'wrench',
		],
		componentName: 'HardwareRepairIcon',
		package: '@atlaskit/icon-lab/core/hardware-repair',
		categorization: 'single-purpose',
		usage: 'Reserved for representing hardware repair.',
		team: 'JSM',
		status: 'published',
	},
	'hardware-return': {
		keywords: [
			'hardware-return',
			'hardwarereturn',
			'icon',
			'icon-lab',
			'screen',
			'display',
			'hardware',
			'return',
			'returned',
		],
		componentName: 'HardwareReturnIcon',
		package: '@atlaskit/icon-lab/core/hardware-return',
		categorization: 'single-purpose',
		usage: 'Reserved for representing returned hardware.',
		team: 'JSM',
		status: 'published',
	},
	'hardware-ship': {
		keywords: [
			'hardware-ship',
			'hardwareship',
			'icon',
			'icon-lab',
			'screen',
			'display',
			'hardware',
			'ship',
			'shipping',
			'shipped',
			'arrow up right',
		],
		componentName: 'HardwareShipIcon',
		package: '@atlaskit/icon-lab/core/hardware-ship',
		categorization: 'single-purpose',
		usage: 'Reserved for representing shipped hardware',
		team: 'JSM',
		status: 'published',
	},
	'hardware-transfer': {
		keywords: [
			'hardware-transfer',
			'hardwaretransfer',
			'icon',
			'icon-lab',
			'screen',
			'display',
			'hardware',
			'transfer',
			'transferred',
			'change ownership',
		],
		componentName: 'HardwareTransferIcon',
		package: '@atlaskit/icon-lab/core/hardware-transfer',
		categorization: 'single-purpose',
		usage: 'Reserved for representing transferred hardware.',
		team: 'JSM',
		status: 'published',
	},
	hierarchy: {
		keywords: [
			'hierarchy',
			'icon',
			'icon-lab',
			'hierarchy',
			'heirarchy',
			'hierachy',
			'relationship',
			'tree',
		],
		componentName: 'HierarchyIcon',
		package: '@atlaskit/icon-lab/core/hierarchy',
		categorization: 'single-purpose',
		usage: 'Reserved for representing the hierarchical relationship between objects.',
		team: 'Transformation',
		status: 'published',
	},
	history: {
		keywords: [
			'history',
			'icon',
			'icon-lab',
			'version control',
			'past',
			'arrow',
			'clock',
			'time',
			'history',
			'recent',
		],
		componentName: 'HistoryIcon',
		package: '@atlaskit/icon-lab/core/history',
		categorization: 'single-purpose',
		usage: 'Reserved for history and recent',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	hourglass: {
		keywords: ['hourglass', 'icon', 'icon-lab'],
		componentName: 'HourglassIcon',
		package: '@atlaskit/icon-lab/core/hourglass',
		categorization: 'multi-purpose',
		usage: 'Aging or expiring items',
		team: 'Trello',
		status: 'published',
		slackChannel: 'joel unger',
	},
	'if-else': {
		keywords: ['if-else', 'ifelse', 'icon', 'icon-lab', 'condition', 'statement', 'branch'],
		componentName: 'IfElseIcon',
		package: '@atlaskit/icon-lab/core/if-else',
		categorization: 'single-purpose',
		usage: 'Reserved for If Else conditions',
		team: 'Automation',
		status: 'published',
		slackChannel: '#help-automation-design',
	},
	'image-alt-text': {
		keywords: ['image-alt-text', 'imagealttext', 'icon', 'icon-lab'],
		componentName: 'ImageAltTextIcon',
		package: '@atlaskit/icon-lab/core/image-alt-text',
		categorization: 'single-purpose',
		usage: 'Reserved for creating alt text for an image',
		team: 'Editor',
		status: 'published',
		slackChannel: '#editor-design',
	},
	'image-crop': {
		keywords: ['image-crop', 'imagecrop', 'icon', 'icon-lab', 'crop', 'crop tool', 'trim'],
		componentName: 'ImageCropIcon',
		package: '@atlaskit/icon-lab/core/image-crop',
		categorization: 'single-purpose',
		usage: 'Reserved for cropping images',
		team: 'Design System Team',
		status: 'published',
	},
	'image-ratio-auto': {
		keywords: [
			'image-ratio-auto',
			'imageratioauto',
			'icon',
			'icon-lab',
			'automatic ratio',
			'ratio',
			'ratio auto',
		],
		componentName: 'ImageRatioAutoIcon',
		package: '@atlaskit/icon-lab/core/image-ratio-auto',
		categorization: 'multi-purpose',
		usage: 'Known uses: Auto detect ratio in the image generation process',
		team: 'Editor',
		status: 'published',
	},
	'image-ratio-narrow': {
		keywords: [
			'image-ratio-narrow',
			'imagerationarrow',
			'icon',
			'icon-lab',
			'narrow',
			'ratio narrow',
			'rectangle',
		],
		componentName: 'ImageRatioNarrowIcon',
		package: '@atlaskit/icon-lab/core/image-ratio-narrow',
		categorization: 'multi-purpose',
		usage: 'Known uses: Narrow image ratio',
		team: 'Editor',
		status: 'published',
	},
	'image-ratio-portrait': {
		keywords: [
			'image-ratio-portrait',
			'imageratioportrait',
			'icon',
			'icon-lab',
			'portrait',
			'rectangle',
			'ratio portrait',
		],
		componentName: 'ImageRatioPortraitIcon',
		package: '@atlaskit/icon-lab/core/image-ratio-portrait',
		categorization: 'multi-purpose',
		usage: 'Known uses: Portrait image ratio',
		team: 'Editor',
		status: 'published',
	},
	'image-ratio-wide': {
		keywords: [
			'image-ratio-wide',
			'imageratiowide',
			'icon',
			'icon-lab',
			'wide',
			'ratio wide',
			'wide ratio',
			'rectangle',
		],
		componentName: 'ImageRatioWideIcon',
		package: '@atlaskit/icon-lab/core/image-ratio-wide',
		categorization: 'multi-purpose',
		usage: 'Known uses: Wide image ratio',
		team: 'Editor',
		status: 'published',
	},
	'image-strikethrough': {
		keywords: [
			'image-strikethrough',
			'imagestrikethrough',
			'icon',
			'icon-lab',
			'image',
			'strikethrough',
			'hide images',
		],
		componentName: 'ImageStrikethroughIcon',
		package: '@atlaskit/icon-lab/core/image-strikethrough',
		categorization: 'multi-purpose',
		usage: "Known uses: Represents 'hide images' action in Loom Workflows.",
		team: 'Loom Core Product - Workflows',
		status: 'published',
		slackChannel: '#pod-workflows',
	},
	incognito: {
		keywords: ['incognito', 'icon', 'icon-lab', 'Whiteboards', 'Private', 'Incognito'],
		componentName: 'IncognitoIcon',
		package: '@atlaskit/icon-lab/core/incognito',
		categorization: 'single-purpose',
		usage: 'Toggle Whiteboards private mode on and off.',
		team: 'Whiteboards',
		status: 'published',
	},
	initiative: {
		keywords: [
			'initiative',
			'icon',
			'icon-lab',
			'crystal ball',
			'system object',
			'work collection',
			'work type',
		],
		componentName: 'InitiativeIcon',
		package: '@atlaskit/icon-lab/core/initiative',
		categorization: 'single-purpose',
		usage: 'Reserved for initiative work type.',
		team: 'Jira Enterprise',
		status: 'published',
	},
	jira: {
		keywords: ['jira', 'icon', 'icon-lab'],
		componentName: 'JiraIcon',
		package: '@atlaskit/icon-lab/core/jira',
		categorization: 'single-purpose',
		usage: 'Representing JIRA',
		team: 'Whiteboards',
		status: 'published',
	},
	'jira-add': {
		keywords: ['jira-add', 'jiraadd', 'icon', 'icon-lab', 'Jira', 'Work items', 'Create'],
		componentName: 'JiraAddIcon',
		package: '@atlaskit/icon-lab/core/jira-add',
		categorization: 'single-purpose',
		usage: 'Reserved for adding Jira work items',
		team: 'Whiteboards',
		status: 'published',
	},
	'jira-upload': {
		keywords: [
			'jira-upload',
			'jiraupload',
			'icon',
			'icon-lab',
			'Jira',
			'Work items',
			'Import',
			'Arrow up',
		],
		componentName: 'JiraUploadIcon',
		package: '@atlaskit/icon-lab/core/jira-upload',
		categorization: 'single-purpose',
		usage: 'Reserved for importing Jira work items',
		team: 'Whiteboards',
		status: 'published',
	},
	journeys: {
		keywords: ['journeys', 'icon', 'icon-lab', 'JSM', 'journey', 'lifecycle', 'map', 'process'],
		componentName: 'JourneysIcon',
		package: '@atlaskit/icon-lab/core/journeys',
		categorization: 'single-purpose',
		usage: 'Reserved for representing Journeys in JSM.',
		team: 'JSM Getting Started',
		status: 'published',
	},
	kanban: {
		keywords: ['kanban', 'icon', 'icon-lab'],
		componentName: 'KanbanIcon',
		package: '@atlaskit/icon-lab/core/kanban',
		categorization: 'single-purpose',
		usage: 'Kanban board',
		team: 'Trello',
		status: 'published',
		slackChannel: '@joel unger',
	},
	key: {
		keywords: ['key', 'icon', 'icon-lab', 'key'],
		componentName: 'KeyIcon',
		package: '@atlaskit/icon-lab/core/key',
		categorization: 'multi-purpose',
		usage: 'Known uses: Foreign key or primary key of a data table.',
		team: 'Data Experiences',
		status: 'published',
	},
	keyboard: {
		keywords: ['keyboard', 'icon', 'icon-lab', 'keyboard', 'qwerty'],
		componentName: 'KeyboardIcon',
		package: '@atlaskit/icon-lab/core/keyboard',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	lasso: {
		keywords: ['lasso', 'icon', 'icon-lab', 'lasso', 'lassoo', 'rope', 'selection'],
		componentName: 'LassoIcon',
		package: '@atlaskit/icon-lab/core/lasso',
		categorization: 'multi-purpose',
		usage: 'Making a selection',
		team: 'Design System Team',
		status: 'published',
	},
	'layout-five-columns': {
		keywords: [
			'layout-five-columns',
			'layoutfivecolumns',
			'icon',
			'icon-lab',
			'layout',
			'columns',
			'5 col',
			'5 cols',
		],
		componentName: 'LayoutFiveColumnsIcon',
		package: '@atlaskit/icon-lab/core/layout-five-columns',
		categorization: 'single-purpose',
		usage: 'Reserved for 5 column layout option in Confluence Editor.',
		team: 'Confluence Editor',
		status: 'published',
	},
	'layout-four-columns': {
		keywords: [
			'layout-four-columns',
			'layoutfourcolumns',
			'icon',
			'icon-lab',
			'layout',
			'columns',
			'4 col',
			'4 cols',
		],
		componentName: 'LayoutFourColumnsIcon',
		package: '@atlaskit/icon-lab/core/layout-four-columns',
		categorization: 'single-purpose',
		usage: 'Reserved for 4 columns layout option in Confluence Editor.',
		team: 'Confluence Editor',
		status: 'published',
	},
	'layout-three-columns-sidebars-left': {
		keywords: [
			'layout-three-columns-sidebars-left',
			'layoutthreecolumnssidebarsleft',
			'icon',
			'icon-lab',
			'layout',
			'columns',
			'3 col',
			'3 cols',
			'sidebars',
			'asides',
		],
		componentName: 'LayoutThreeColumnsSidebarsLeftIcon',
		package: '@atlaskit/icon-lab/core/layout-three-columns-sidebars-left',
		categorization: 'single-purpose',
		usage: 'Reserved for 3 column layout with 2 sidebars on left option in Confluence Editor.',
		team: 'Editor',
		status: 'published',
	},
	'layout-three-columns-sidebars-right': {
		keywords: [
			'layout-three-columns-sidebars-right',
			'layoutthreecolumnssidebarsright',
			'icon',
			'icon-lab',
			'layout',
			'columns',
			'3 col',
			'3 cols',
			'sidebars',
			'asides',
		],
		componentName: 'LayoutThreeColumnsSidebarsRightIcon',
		package: '@atlaskit/icon-lab/core/layout-three-columns-sidebars-right',
		categorization: 'single-purpose',
		usage: 'Reserved for 3 column layout with 2 sidebars on right option in Confluence Editor.',
		team: 'Editor',
		status: 'published',
	},
	'link-restricted-access': {
		keywords: [
			'link-restricted-access',
			'linkrestrictedaccess',
			'icon',
			'icon-lab',
			'link',
			'strikethrough',
			'limited',
		],
		componentName: 'LinkRestrictedAccessIcon',
		package: '@atlaskit/icon-lab/core/link-restricted-access',
		categorization: 'single-purpose',
		usage: 'Reserved for when there is limited link permissions',
		team: 'Loom',
		status: 'published',
	},
	loom: {
		keywords: ['loom', 'icon', 'icon-lab', 'loom'],
		componentName: 'LoomIcon',
		package: '@atlaskit/icon-lab/core/loom',
		categorization: 'single-purpose',
		usage: "Used only for representing the object type of \'a Loom\'",
		team: 'Design System',
		status: 'published',
	},
	lozenge: {
		keywords: ['lozenge', 'icon', 'icon-lab', 'insert', 'status', 'badge'],
		componentName: 'LozengeIcon',
		package: '@atlaskit/icon-lab/core/lozenge',
		categorization: 'single-purpose',
		usage: 'Reserved for inserting status lozenges in Editor.',
		team: 'Editor',
		status: 'published',
	},
	'merge-queue': {
		keywords: [
			'merge-queue',
			'mergequeue',
			'icon',
			'icon-lab',
			'bitbucket',
			'repository',
			'merge queue',
			'git',
			'version control',
		],
		componentName: 'MergeQueueIcon',
		package: '@atlaskit/icon-lab/core/merge-queue',
		categorization: 'single-purpose',
		usage: 'Reserved for representing merge queue functionality.',
		team: 'Bitbucket DC',
		status: 'published',
	},
	'microphone-strikethrough': {
		keywords: [
			'microphone-strikethrough',
			'microphonestrikethrough',
			'icon',
			'icon-lab',
			'mic',
			'no audio',
			'off',
		],
		componentName: 'MicrophoneStrikethroughIcon',
		package: '@atlaskit/icon-lab/core/microphone-strikethrough',
		categorization: 'multi-purpose',
		usage: 'Reserved for no microphone input',
		team: 'Loom',
		status: 'published',
	},
	'milestone-complete': {
		keywords: [
			'milestone-complete',
			'milestonecomplete',
			'icon',
			'icon-lab',
			'milestone',
			'completed',
			'check mark',
			'roadmaps',
			'calendar',
		],
		componentName: 'MilestoneCompleteIcon',
		package: '@atlaskit/icon-lab/core/milestone-complete',
		categorization: 'single-purpose',
		usage: 'Reserved for representing a completed milestone.',
		team: 'Jira Align',
		status: 'published',
	},
	'milestone-incomplete': {
		keywords: [
			'milestone-incomplete',
			'milestoneincomplete',
			'icon',
			'icon-lab',
			'milestone',
			'incompleted',
			'roadmaps',
			'calendar',
		],
		componentName: 'MilestoneIncompleteIcon',
		package: '@atlaskit/icon-lab/core/milestone-incomplete',
		categorization: 'single-purpose',
		usage: 'Reserved for representing an incomplete milestone.',
		team: 'Jira Align',
		status: 'published',
	},
	'milestone-multiple': {
		keywords: [
			'milestone-multiple',
			'milestonemultiple',
			'icon',
			'icon-lab',
			'milestone',
			'milestones',
			'multiple milestones',
			'roadmaps',
			'calendar',
		],
		componentName: 'MilestoneMultipleIcon',
		package: '@atlaskit/icon-lab/core/milestone-multiple',
		categorization: 'single-purpose',
		usage: 'Reserved for use when multiple milestones occur on a single date or point in time.',
		team: 'Jira Align',
		status: 'published',
	},
	'milestone-overdue': {
		keywords: [
			'milestone-overdue',
			'milestoneoverdue',
			'icon',
			'icon-lab',
			'overdue',
			'past due',
			'milestone',
			'roadmaps',
			'calendar',
		],
		componentName: 'MilestoneOverdueIcon',
		package: '@atlaskit/icon-lab/core/milestone-overdue',
		categorization: 'single-purpose',
		usage: 'Reserved for representing an overdue milestone.',
		team: 'Jira Align',
		status: 'published',
	},
	'missed-call': {
		keywords: [
			'missed-call',
			'missedcall',
			'icon',
			'icon-lab',
			'missed phone call',
			'rejected call',
		],
		componentName: 'MissedCallIcon',
		package: '@atlaskit/icon-lab/core/missed-call',
		categorization: 'single-purpose',
		usage: 'Reserved for representing missed calls and missed call settings.',
		team: 'IT Operations (ITSM)',
		status: 'published',
	},
	'node-parallel-bottom-left': {
		keywords: [
			'node-parallel-bottom-left',
			'nodeparallelbottomleft',
			'icon',
			'icon-lab',
			'Node',
			'Parallel',
			'Bottom',
			'Left',
		],
		componentName: 'NodeParallelBottomLeftIcon',
		package: '@atlaskit/icon-lab/core/node-parallel-bottom-left',
		categorization: 'single-purpose',
		usage: 'Reserved for whiteboard’s node parallel-bottom-left',
		team: 'Whiteboards',
		status: 'published',
	},
	'node-parallel-bottom-right': {
		keywords: [
			'node-parallel-bottom-right',
			'nodeparallelbottomright',
			'icon',
			'icon-lab',
			'Node',
			'parallel',
			'bottom',
			'right',
		],
		componentName: 'NodeParallelBottomRightIcon',
		package: '@atlaskit/icon-lab/core/node-parallel-bottom-right',
		categorization: 'single-purpose',
		usage: 'Reserved for whiteboard’s node parallel-bottom-right',
		team: 'Whiteboards',
		status: 'published',
	},
	'node-parallel-top-left': {
		keywords: [
			'node-parallel-top-left',
			'nodeparalleltopleft',
			'icon',
			'icon-lab',
			'Node',
			'Parallel',
			'Top',
			'Left',
		],
		componentName: 'NodeParallelTopLeftIcon',
		package: '@atlaskit/icon-lab/core/node-parallel-top-left',
		categorization: 'single-purpose',
		usage: 'Reserved for whiteboard’s node parallel-top-left',
		team: 'Whiteboards',
		status: 'published',
	},
	'node-parallel-top-right': {
		keywords: [
			'node-parallel-top-right',
			'nodeparalleltopright',
			'icon',
			'icon-lab',
			'Node',
			'parallel',
			'top',
			'right',
		],
		componentName: 'NodeParallelTopRightIcon',
		package: '@atlaskit/icon-lab/core/node-parallel-top-right',
		categorization: 'single-purpose',
		usage: 'Reserved for whiteboard’s node parallel-top-right',
		team: 'Whiteboards',
		status: 'published',
	},
	'node-single-left': {
		keywords: ['node-single-left', 'nodesingleleft', 'icon', 'icon-lab', 'Node', 'Single', 'Left'],
		componentName: 'NodeSingleLeftIcon',
		package: '@atlaskit/icon-lab/core/node-single-left',
		categorization: 'single-purpose',
		usage: 'Reserved for whiteboard’s node single-left alignment',
		team: 'Whiteboards',
		status: 'published',
	},
	'node-single-right': {
		keywords: [
			'node-single-right',
			'nodesingleright',
			'icon',
			'icon-lab',
			'Node',
			'single',
			'right',
		],
		componentName: 'NodeSingleRightIcon',
		package: '@atlaskit/icon-lab/core/node-single-right',
		categorization: 'single-purpose',
		usage: 'Reserved for whiteboard’s node single-right',
		team: 'Whiteboards',
		status: 'published',
	},
	notepad: {
		keywords: ['notepad', 'icon', 'icon-lab', 'Card', 'Note', 'Notepad', 'Memo'],
		componentName: 'NotepadIcon',
		package: '@atlaskit/icon-lab/core/notepad',
		categorization: 'multi-purpose',
		usage: "Whiteboard component \'card\'",
		team: 'Confluence Whiteboards',
		status: 'published',
	},
	'page-live-doc': {
		keywords: [
			'page-live-doc',
			'pagelivedoc',
			'icon',
			'icon-lab',
			'page',
			'live edit',
			'lightning bolt',
			'multiplayer',
			'document',
			'live doc',
		],
		componentName: 'PageLiveDocIcon',
		package: '@atlaskit/icon-lab/core/page-live-doc',
		categorization: 'single-purpose',
		usage: 'Reserved for Live Document content type.',
		team: 'Content Types',
		status: 'published',
	},
	'paint-brush': {
		keywords: ['paint-brush', 'paintbrush', 'icon', 'icon-lab', 'brush', 'appearance', 'paint'],
		componentName: 'PaintBrushIcon',
		package: '@atlaskit/icon-lab/core/paint-brush',
		categorization: 'multi-purpose',
		usage: 'Multi purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'paint-roller': {
		keywords: ['paint-roller', 'paintroller', 'icon', 'icon-lab', 'roller', 'background', 'paint'],
		componentName: 'PaintRollerIcon',
		package: '@atlaskit/icon-lab/core/paint-roller',
		categorization: 'multi-purpose',
		usage: 'Multi purpose',
		team: 'Design System Team',
		status: 'published',
	},
	panel: {
		keywords: ['panel', 'icon', 'icon-lab', 'panel', 'card'],
		componentName: 'PanelIcon',
		package: '@atlaskit/icon-lab/core/panel',
		categorization: 'multi-purpose',
		usage: 'Panel category in Confluence',
		team: 'Editor AI',
		status: 'published',
	},
	'party-popper': {
		keywords: [
			'party-popper',
			'partypopper',
			'icon',
			'icon-lab',
			'party',
			'celebrate',
			'celebration',
			'confetti',
		],
		componentName: 'PartyPopperIcon',
		package: '@atlaskit/icon-lab/core/party-popper',
		categorization: 'multi-purpose',
		usage: 'User-selectable icon choice for calendars',
		team: 'Growth Buy',
		status: 'published',
	},
	pencil: {
		keywords: ['pencil', 'icon', 'icon-lab', 'compose', 'write', 'pen'],
		componentName: 'PencilIcon',
		package: '@atlaskit/icon-lab/core/pencil',
		categorization: 'multi-purpose',
		usage: 'Known uses: compose video title in Loom',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'person-assignee': {
		keywords: [
			'person-assignee',
			'personassignee',
			'icon',
			'icon-lab',
			'person',
			'assigned to me',
			'assignee',
		],
		componentName: 'PersonAssigneeIcon',
		package: '@atlaskit/icon-lab/core/person-assignee',
		categorization: 'single-purpose',
		usage: 'Reserved for representing assignees or assigning work to an individual.',
		team: 'Jira UX Transformation',
		status: 'published',
	},
	'person-lock-locked': {
		keywords: [
			'person-lock-locked',
			'personlocklocked',
			'icon',
			'icon-lab',
			'person',
			'permissions',
			'locked',
			'restricted access',
		],
		componentName: 'PersonLockLockedIcon',
		package: '@atlaskit/icon-lab/core/person-lock-locked',
		categorization: 'single-purpose',
		usage: 'Reserved for restricted user permissions or access.',
		team: 'JSM',
		status: 'published',
	},
	'person-lock-unlocked': {
		keywords: [
			'person-lock-unlocked',
			'personlockunlocked',
			'icon',
			'icon-lab',
			'person',
			'permissions',
			'unlocked',
			'unrestricted access',
		],
		componentName: 'PersonLockUnlockedIcon',
		package: '@atlaskit/icon-lab/core/person-lock-unlocked',
		categorization: 'single-purpose',
		usage: 'Reserved for unrestricted user permissions or access.',
		team: 'JSM',
		status: 'published',
	},
	'person-voiceover': {
		keywords: [
			'person-voiceover',
			'personvoiceover',
			'icon',
			'icon-lab',
			'voice',
			'speak',
			'speech',
			'human',
			'user',
		],
		componentName: 'PersonVoiceoverIcon',
		package: '@atlaskit/icon-lab/core/person-voiceover',
		categorization: 'single-purpose',
		usage: 'Known uses: voiceover within Loom Variables',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'pin-strikethrough': {
		keywords: [
			'pin-strikethrough',
			'pinstrikethrough',
			'icon',
			'icon-lab',
			'push pin',
			'thumbtack',
			'tack',
			'unpin',
		],
		componentName: 'PinStrikethroughIcon',
		package: '@atlaskit/icon-lab/core/pin-strikethrough',
		categorization: 'multi-purpose',
		usage: 'Known uses: Unpinning comments in Jira',
		team: 'Jira',
		status: 'published',
	},
	pipeline: {
		keywords: ['pipeline', 'icon', 'icon-lab', 'pipeline', 'build process', 'bitbucket'],
		componentName: 'PipelineIcon',
		package: '@atlaskit/icon-lab/core/pipeline',
		categorization: 'single-purpose',
		usage: 'Reserved for representing pipelines',
		team: 'Bitbucket Cloud',
		status: 'published',
	},
	plan: {
		keywords: ['plan', 'icon', 'icon-lab', 'roadmaps', 'plan'],
		componentName: 'PlanIcon',
		package: '@atlaskit/icon-lab/core/plan',
		categorization: 'single-purpose',
		usage: 'Reserved for representing plans.',
		team: 'Design System Team',
		status: 'published',
	},
	playlist: {
		keywords: ['playlist', 'icon', 'icon-lab', 'playlist', 'listen', 'audio', 'play', 'briefing'],
		componentName: 'PlaylistIcon',
		package: '@atlaskit/icon-lab/core/playlist',
		categorization: 'single-purpose',
		usage: 'Representing the playlist feature',
		team: 'Confluence Horizontals',
		status: 'published',
		slackChannel: 'confluence-design',
	},
	'playlist-add': {
		keywords: [
			'playlist-add',
			'playlistadd',
			'icon',
			'icon-lab',
			'playlist',
			'add',
			'include',
			'bookmark',
			'listen',
			'save',
		],
		componentName: 'PlaylistAddIcon',
		package: '@atlaskit/icon-lab/core/playlist-add',
		categorization: 'single-purpose',
		usage: 'Adding items to your playlist (feature).',
		team: 'Confluence Horizontals',
		status: 'published',
		slackChannel: 'design-confluence',
	},
	'playlist-added': {
		keywords: [
			'playlist-added',
			'playlistadded',
			'icon',
			'icon-lab',
			'playlist',
			'added',
			'include',
			'play',
		],
		componentName: 'PlaylistAddedIcon',
		package: '@atlaskit/icon-lab/core/playlist-added',
		categorization: 'single-purpose',
		usage: 'Indicating when things have been added to your playlist (feature)',
		team: 'Confluence Horizontals',
		status: 'published',
		slackChannel: 'confluence-design',
	},
	'playlist-remove': {
		keywords: [
			'playlist-remove',
			'playlistremove',
			'icon',
			'icon-lab',
			'playlist',
			'remove',
			'cancel',
			'delete',
		],
		componentName: 'PlaylistRemoveIcon',
		package: '@atlaskit/icon-lab/core/playlist-remove',
		categorization: 'single-purpose',
		usage: 'Represents the action for removing things from the playlist feature.',
		team: 'Confluence Horizontals',
		status: 'published',
		slackChannel: 'confluence-design',
	},
	'plus-circle': {
		keywords: ['plus-circle', 'pluscircle', 'icon', 'icon-lab', 'add'],
		componentName: 'PlusCircleIcon',
		package: '@atlaskit/icon-lab/core/plus-circle',
		categorization: 'multi-purpose',
		usage: 'Known uses: add task in Loom',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	power: {
		keywords: ['power', 'icon', 'icon-lab', 'energy', 'turn on', 'turn off', 'power off'],
		componentName: 'PowerIcon',
		package: '@atlaskit/icon-lab/core/power',
		categorization: 'multi-purpose',
		usage: 'Known uses: Turn off Loom companion in Chrome extension',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'power-cable': {
		keywords: [
			'power-cable',
			'powercable',
			'icon',
			'icon-lab',
			'plugs',
			'plugin',
			'plug-in',
			'connection',
			'connectivity',
			'cable',
			'extensibility',
			'power cord',
		],
		componentName: 'PowerCableIcon',
		package: '@atlaskit/icon-lab/core/power-cable',
		categorization: 'multi-purpose',
		usage: 'Suggested uses: Data connectivity, Connection, Plugins, Extensions, Extensibility',
		team: 'Design System Team',
		status: 'published',
	},
	'qr-code': {
		keywords: ['qr-code', 'qrcode', 'icon', 'icon-lab', 'QR code', 'barcode'],
		componentName: 'QrCodeIcon',
		package: '@atlaskit/icon-lab/core/qr-code',
		categorization: 'single-purpose',
		usage: 'Reserved for QR code experiences.',
		team: 'Assets',
		status: 'published',
	},
	'queue-pop-in': {
		keywords: [
			'queue-pop-in',
			'queuepopin',
			'icon',
			'icon-lab',
			'Queues',
			'pop-in',
			'pop in',
			'move back to sidebar',
		],
		componentName: 'QueuePopInIcon',
		package: '@atlaskit/icon-lab/core/queue-pop-in',
		categorization: 'single-purpose',
		usage: 'Reserved for JSM queue navigation to move back to sidebar',
		team: 'JSM core capabilities',
		status: 'published',
	},
	'queue-pop-out': {
		keywords: [
			'queue-pop-out',
			'queuepopout',
			'icon',
			'icon-lab',
			'pop-out',
			'pop out',
			'Queues',
			'Move out from sidebar',
		],
		componentName: 'QueuePopOutIcon',
		package: '@atlaskit/icon-lab/core/queue-pop-out',
		categorization: 'single-purpose',
		usage: 'Reserved for JSM queue navigation to pop out from sidebar',
		team: 'JSM core capabilities',
		status: 'published',
	},
	randomize: {
		keywords: ['randomize', 'icon', 'icon-lab', 'randomize', 'randomise', 'shuffle'],
		componentName: 'RandomizeIcon',
		package: '@atlaskit/icon-lab/core/randomize',
		categorization: 'single-purpose',
		usage: 'Reserved for randomizing or shuffling functionality.',
		team: 'Whiteboards',
		status: 'published',
	},
	'registry-service': {
		keywords: ['registry-service', 'registryservice', 'icon', 'icon-lab', 'service registry'],
		componentName: 'RegistryServiceIcon',
		package: '@atlaskit/icon-lab/core/registry-service',
		categorization: 'single-purpose',
		usage:
			'Reserved for representing a service registry — a category of software, capabilities, and application services.',
		team: 'JSM',
		status: 'published',
	},
	repeat: {
		keywords: ['repeat', 'icon', 'icon-lab', 'recur', 'recurring', 'repeat', 'repeating'],
		componentName: 'RepeatIcon',
		package: '@atlaskit/icon-lab/core/repeat',
		categorization: 'single-purpose',
		usage: 'Reserved for setting objects to recur (eg Work items, Forms)',
		team: 'Pandora',
		status: 'published',
		slackChannel: '#horizon-pandora-eng',
	},
	'reply-left': {
		keywords: [
			'reply-left',
			'replyleft',
			'icon',
			'icon-lab',
			'arrow',
			'reply',
			'respond',
			'message',
		],
		componentName: 'ReplyLeftIcon',
		package: '@atlaskit/icon-lab/core/reply-left',
		categorization: 'single-purpose',
		usage: 'Known uses: replying to a message thread',
		team: 'Loom',
		status: 'published',
	},
	'reply-right': {
		keywords: ['reply-right', 'replyright', 'icon', 'icon-lab'],
		componentName: 'ReplyRightIcon',
		package: '@atlaskit/icon-lab/core/reply-right',
		categorization: 'single-purpose',
		usage: 'Known uses: replying to a message thread',
		team: 'Loom',
		status: 'published',
	},
	return: {
		keywords: ['return', 'icon', 'icon-lab', 'submit', 'return', 'enter', 'confirm'],
		componentName: 'ReturnIcon',
		package: '@atlaskit/icon-lab/core/return',
		categorization: 'single-purpose',
		usage: 'Reserved for submitting text fields without dedicated button, mainly AI prompts',
		team: 'Data Experiences (AVP)',
		status: 'published',
		slackChannel: '#avp-design',
	},
	risk: {
		keywords: ['risk', 'icon', 'icon-lab', 'risk', 'stop sign'],
		componentName: 'RiskIcon',
		package: '@atlaskit/icon-lab/core/risk',
		categorization: 'single-purpose',
		usage: 'Reserved for representing risks.',
		team: 'Focus',
		status: 'published',
	},
	'roadmaps-plan': {
		keywords: ['roadmaps-plan', 'roadmapsplan', 'icon', 'icon-lab', 'roadmaps', 'plan'],
		componentName: 'RoadmapsPlanIcon',
		package: '@atlaskit/icon-lab/core/roadmaps-plan',
		replacement: { name: 'plan', location: '@atlaskit/icon-lab' },
		categorization: 'single-purpose',
		usage: 'Reserved for representing plans.',
		team: 'Design System Team',
		status: 'deprecated',
	},
	'roadmaps-service': {
		keywords: [
			'roadmaps-service',
			'roadmapsservice',
			'icon',
			'icon-lab',
			'roadmaps',
			'service',
			'roadmap',
		],
		componentName: 'RoadmapsServiceIcon',
		package: '@atlaskit/icon-lab/core/roadmaps-service',
		replacement: { name: 'service', location: '@atlaskit/icon-lab' },
		categorization: 'single-purpose',
		usage: 'Reserved for roadmaps service.',
		team: 'Design System Team',
		status: 'deprecated',
	},
	rovo: {
		keywords: ['rovo', 'icon', 'icon-lab', 'rovo', 'AI chat'],
		componentName: 'RovoIcon',
		package: '@atlaskit/icon-lab/core/rovo',
		categorization: 'single-purpose',
		usage: 'Reserved for representing Rovo',
		team: 'Design System Team',
		status: 'published',
	},
	'rss-feed': {
		keywords: [
			'rss-feed',
			'rssfeed',
			'icon',
			'icon-lab',
			'rss',
			'really simply syndication',
			'web feed',
			'xml',
		],
		componentName: 'RssFeedIcon',
		package: '@atlaskit/icon-lab/core/rss-feed',
		categorization: 'single-purpose',
		usage: 'Reserved for RSS feeds',
		team: 'Design System Team',
		status: 'published',
	},
	save: {
		keywords: [
			'save',
			'icon',
			'icon-lab',
			'floppy disk',
			'save',
			'floppy drive',
			'storage',
			'diskette',
		],
		componentName: 'SaveIcon',
		package: '@atlaskit/icon-lab/core/save',
		categorization: 'single-purpose',
		usage: 'Reserved for saving',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'screen-record': {
		keywords: [
			'screen-record',
			'screenrecord',
			'icon',
			'icon-lab',
			'screen recorder',
			'camera',
			'cam bubble',
		],
		componentName: 'ScreenRecordIcon',
		package: '@atlaskit/icon-lab/core/screen-record',
		categorization: 'single-purpose',
		usage: 'Known uses: screen recorder with the cam bubble for Loom',
		team: 'Loom',
		status: 'published',
	},
	section: {
		keywords: ['section', 'icon', 'icon-lab', 'section', 'related content'],
		componentName: 'SectionIcon',
		package: '@atlaskit/icon-lab/core/section',
		categorization: 'multi-purpose',
		usage: 'Used for section tool in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	service: {
		keywords: ['service', 'icon', 'icon-lab', 'roadmaps', 'service', 'roadmap'],
		componentName: 'ServiceIcon',
		package: '@atlaskit/icon-lab/core/service',
		categorization: 'single-purpose',
		usage: 'Reserved for roadmaps service.',
		team: 'Design System Team',
		status: 'published',
	},
	'shape-diamond': {
		keywords: ['shape-diamond', 'shapediamond', 'icon', 'icon-lab', 'diamond', 'shape tool'],
		componentName: 'ShapeDiamondIcon',
		package: '@atlaskit/icon-lab/core/shape-diamond',
		categorization: 'multi-purpose',
		usage: 'Diamond shape tool in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'shape-ellipse': {
		keywords: [
			'shape-ellipse',
			'shapeellipse',
			'icon',
			'icon-lab',
			'ellipse',
			'circle',
			'shape tool',
		],
		componentName: 'ShapeEllipseIcon',
		package: '@atlaskit/icon-lab/core/shape-ellipse',
		categorization: 'multi-purpose',
		usage: 'Ellipse shape tool in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'shape-parallelogram-skew-left': {
		keywords: [
			'shape-parallelogram-skew-left',
			'shapeparallelogramskewleft',
			'icon',
			'icon-lab',
			'parallelogram',
			'skewed',
			'left',
			'shape tool',
		],
		componentName: 'ShapeParallelogramSkewLeftIcon',
		package: '@atlaskit/icon-lab/core/shape-parallelogram-skew-left',
		categorization: 'multi-purpose',
		usage: 'Left parallelogram shape tool in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'shape-parallelogram-skew-right': {
		keywords: [
			'shape-parallelogram-skew-right',
			'shapeparallelogramskewright',
			'icon',
			'icon-lab',
			'parallelogram',
			'skewed',
			'shape tool',
			'right',
		],
		componentName: 'ShapeParallelogramSkewRightIcon',
		package: '@atlaskit/icon-lab/core/shape-parallelogram-skew-right',
		categorization: 'multi-purpose',
		usage: 'Right parallelogram shape tool in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'shape-rectangle': {
		keywords: [
			'shape-rectangle',
			'shaperectangle',
			'icon',
			'icon-lab',
			'shape tool',
			'rectangle',
			'square',
		],
		componentName: 'ShapeRectangleIcon',
		package: '@atlaskit/icon-lab/core/shape-rectangle',
		categorization: 'multi-purpose',
		usage: 'Rectangle shape tool in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'shape-rectangle-rounded': {
		keywords: [
			'shape-rectangle-rounded',
			'shaperectanglerounded',
			'icon',
			'icon-lab',
			'shape tool',
			'rectangle',
			'rounded',
			'square',
		],
		componentName: 'ShapeRectangleRoundedIcon',
		package: '@atlaskit/icon-lab/core/shape-rectangle-rounded',
		categorization: 'multi-purpose',
		usage: 'Rounded rectangle shape tool in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'shape-triangle': {
		keywords: [
			'shape-triangle',
			'shapetriangle',
			'icon',
			'icon-lab',
			'triangle',
			'shape tool',
			'equilateral',
		],
		componentName: 'ShapeTriangleIcon',
		package: '@atlaskit/icon-lab/core/shape-triangle',
		categorization: 'multi-purpose',
		usage: 'Triangle shape tool in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'shape-triangle-inverted': {
		keywords: [
			'shape-triangle-inverted',
			'shapetriangleinverted',
			'icon',
			'icon-lab',
			'triangle',
			'shape tool',
			'equilateral',
		],
		componentName: 'ShapeTriangleInvertedIcon',
		package: '@atlaskit/icon-lab/core/shape-triangle-inverted',
		categorization: 'multi-purpose',
		usage: 'Upside down triangle shape tool in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	signature: {
		keywords: [
			'signature',
			'icon',
			'icon-lab',
			'signature',
			'scribble',
			'author',
			'authour',
			'sticky note',
			'post-it',
		],
		componentName: 'SignatureIcon',
		package: '@atlaskit/icon-lab/core/signature',
		categorization: 'multi-purpose',
		usage: 'Toggle author visibility on sticky notes in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	signpost: {
		keywords: ['signpost', 'icon', 'icon-lab', 'signpost', 'direction', 'milestone'],
		componentName: 'SignpostIcon',
		package: '@atlaskit/icon-lab/core/signpost',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	skill: {
		keywords: ['skill', 'icon', 'icon-lab', 'skill', 'skills', 'agent', 'agentic', 'tools', 'tool'],
		componentName: 'SkillIcon',
		package: '@atlaskit/icon-lab/core/skill',
		categorization: 'single-purpose',
		usage:
			'Reserved for skill functionality. Skills are a combination of tools and a prompt to allow an agent to perform a multistep process.',
		team: 'Studio',
		status: 'published',
	},
	skip: {
		keywords: ['skip', 'icon', 'icon-lab', 'skip', 'miss'],
		componentName: 'SkipIcon',
		package: '@atlaskit/icon-lab/core/skip',
		categorization: 'single-purpose',
		usage: 'Reserved for skipping steps.',
		team: 'Automation',
		status: 'published',
	},
	'skip-unskip': {
		keywords: ['skip-unskip', 'skipunskip', 'icon', 'icon-lab', 'unskip', 'reinstate step'],
		componentName: 'SkipUnskipIcon',
		package: '@atlaskit/icon-lab/core/skip-unskip',
		categorization: 'single-purpose',
		usage: 'Reserved for reinstating a previously skipped step.',
		team: 'Automation',
		status: 'published',
	},
	'sort-options': {
		keywords: [
			'sort-options',
			'sortoptions',
			'icon',
			'icon-lab',
			'sorting',
			'ordering',
			'alphabetization',
			'alphabetisation',
			'reordering',
		],
		componentName: 'SortOptionsIcon',
		package: '@atlaskit/icon-lab/core/sort-options',
		categorization: 'single-purpose',
		usage: 'Reserved for accessing sorting options.',
		team: 'Databases',
		status: 'published',
	},
	spaces: {
		keywords: ['spaces', 'icon', 'icon-lab', 'space', 'spaces', 'projects'],
		componentName: 'SpacesIcon',
		package: '@atlaskit/icon-lab/core/spaces',
		categorization: 'single-purpose',
		usage:
			'Reserved for use for Jira Projects for now. This will replace the Jira rocket.   More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.',
		team: 'Jira',
		status: 'published',
		slackChannel: '#jira-design-system-figma-libraries',
	},
	'speedometer-left': {
		keywords: [
			'speedometer-left',
			'speedometerleft',
			'icon',
			'icon-lab',
			'speed',
			'performance',
			'dial',
			'slow',
		],
		componentName: 'SpeedometerLeftIcon',
		package: '@atlaskit/icon-lab/core/speedometer-left',
		categorization: 'multi-purpose',
		usage: 'Known uses: video is set to a slower playback speed',
		team: 'Loom',
		status: 'published',
	},
	'speedometer-left-down': {
		keywords: [
			'speedometer-left-down',
			'speedometerleftdown',
			'icon',
			'icon-lab',
			'speed',
			'performance',
			'dial',
			'slowest',
			'risk likelihood',
			'low risk',
		],
		componentName: 'SpeedometerLeftDownIcon',
		package: '@atlaskit/icon-lab/core/speedometer-left-down',
		categorization: 'multi-purpose',
		usage: 'Known uses: low risk likelihood',
		team: 'Focus',
		status: 'published',
	},
	'speedometer-left-up': {
		keywords: [
			'speedometer-left-up',
			'speedometerleftup',
			'icon',
			'icon-lab',
			'speed',
			'performance',
			'dial',
			'slow',
			'risk likelihood',
			'medium low risk',
		],
		componentName: 'SpeedometerLeftUpIcon',
		package: '@atlaskit/icon-lab/core/speedometer-left-up',
		categorization: 'multi-purpose',
		usage: 'Known uses: video is set to a slower playback speed; medium-low risk likelihood',
		team: 'Loom',
		status: 'published',
	},
	'speedometer-right': {
		keywords: [
			'speedometer-right',
			'speedometerright',
			'icon',
			'icon-lab',
			'speed',
			'performance',
			'dial',
			'fast',
		],
		componentName: 'SpeedometerRightIcon',
		package: '@atlaskit/icon-lab/core/speedometer-right',
		categorization: 'multi-purpose',
		usage: 'Known uses: video is set to a faster playback speed',
		team: 'Loom',
		status: 'published',
	},
	'speedometer-right-down': {
		keywords: [
			'speedometer-right-down',
			'speedometerrightdown',
			'icon',
			'icon-lab',
			'speed',
			'performance',
			'dial',
			'fastest',
			'risk likelihood',
			'high risk',
		],
		componentName: 'SpeedometerRightDownIcon',
		package: '@atlaskit/icon-lab/core/speedometer-right-down',
		categorization: 'multi-purpose',
		usage: 'Known uses: high risk likelihood',
		team: 'Focus',
		status: 'published',
	},
	'speedometer-right-up': {
		keywords: [
			'speedometer-right-up',
			'speedometerrightup',
			'icon',
			'icon-lab',
			'speed',
			'performance',
			'dial',
			'fast',
			'risk likelihood',
			'medium high risk',
		],
		componentName: 'SpeedometerRightUpIcon',
		package: '@atlaskit/icon-lab/core/speedometer-right-up',
		categorization: 'multi-purpose',
		usage: 'Known uses: video is set to a faster playback speed; medium-high risk likelihood',
		team: 'Loom',
		status: 'published',
	},
	'speedometer-up': {
		keywords: [
			'speedometer-up',
			'speedometerup',
			'icon',
			'icon-lab',
			'speed',
			'performance',
			'dial',
			'risk likelihood',
			'medium risk',
		],
		componentName: 'SpeedometerUpIcon',
		package: '@atlaskit/icon-lab/core/speedometer-up',
		categorization: 'multi-purpose',
		usage: 'Known uses: video is set a normal playback speed; medium risk likelihood',
		team: 'Loom',
		status: 'published',
	},
	'split-parallel': {
		keywords: ['split-parallel', 'splitparallel', 'icon', 'icon-lab', 'router', 'branches'],
		componentName: 'SplitParallelIcon',
		package: '@atlaskit/icon-lab/core/split-parallel',
		categorization: 'single-purpose',
		usage: 'Reserved for split parallel branches in Automation',
		team: 'Automation',
		status: 'published',
		slackChannel: '#help-automation-design',
	},
	stamp: {
		keywords: ['stamp', 'icon', 'icon-lab', 'stamp', 'rubber stamp', 'handstamp'],
		componentName: 'StampIcon',
		package: '@atlaskit/icon-lab/core/stamp',
		categorization: 'multi-purpose',
		usage: 'Used for stamp tool in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'status-workflow-cancelled': {
		keywords: [
			'status-workflow-cancelled',
			'statusworkflowcancelled',
			'icon',
			'icon-lab',
			'status',
			'workflow phase',
			'cross',
			'cancelled',
		],
		componentName: 'StatusWorkflowCancelledIcon',
		package: '@atlaskit/icon-lab/core/status-workflow-cancelled',
		categorization: 'single-purpose',
		usage: 'Reserved for representing statuses that indicated work or a process has been cancelled',
		team: 'Design System Team',
		status: 'published',
	},
	'status-workflow-danger': {
		keywords: [
			'status-workflow-danger',
			'statusworkflowdanger',
			'icon',
			'icon-lab',
			'status',
			'workflow phase',
			'danger',
			'critical',
			'blocking',
			'error',
		],
		componentName: 'StatusWorkflowDangerIcon',
		package: '@atlaskit/icon-lab/core/status-workflow-danger',
		categorization: 'single-purpose',
		usage: 'Reserved for representing statuses that signal critical issues that demand attention',
		team: 'Design System Team',
		status: 'published',
	},
	'status-workflow-in-progress': {
		keywords: [
			'status-workflow-in-progress',
			'statusworkflowinprogress',
			'icon',
			'icon-lab',
			'status',
			'workflow phase',
			'in progress',
			'WIP',
		],
		componentName: 'StatusWorkflowInProgressIcon',
		package: '@atlaskit/icon-lab/core/status-workflow-in-progress',
		categorization: 'single-purpose',
		usage:
			"Reserved for representing in progress statuses such as 'In progress', 'In development', 'Draft'",
		team: 'Design System Team',
		status: 'published',
	},
	'status-workflow-in-review': {
		keywords: [
			'status-workflow-in-review',
			'statusworkflowinreview',
			'icon',
			'icon-lab',
			'status',
			'workflow phase',
			'reviewing',
			'considering',
			'assessing',
			'in review',
		],
		componentName: 'StatusWorkflowInReviewIcon',
		package: '@atlaskit/icon-lab/core/status-workflow-in-review',
		categorization: 'single-purpose',
		usage: 'Reserved for representing statuses that signal consideration, assessment, and review',
		team: 'Design System Team',
		status: 'published',
	},
	'status-workflow-inactive': {
		keywords: [
			'status-workflow-inactive',
			'statusworkflowinactive',
			'icon',
			'icon-lab',
			'status',
			'workflow phase',
			'inactive',
		],
		componentName: 'StatusWorkflowInactiveIcon',
		package: '@atlaskit/icon-lab/core/status-workflow-inactive',
		categorization: 'single-purpose',
		usage:
			'Reserved for representing statuses that indicate work or a process is in an inactive state',
		team: 'Design System Team',
		status: 'published',
	},
	'status-workflow-incomplete': {
		keywords: [
			'status-workflow-incomplete',
			'statusworkflowincomplete',
			'icon',
			'icon-lab',
			'status',
			'workflow phase',
			'incomplete',
		],
		componentName: 'StatusWorkflowIncompleteIcon',
		package: '@atlaskit/icon-lab/core/status-workflow-incomplete',
		categorization: 'single-purpose',
		usage:
			"Reserved for representing incomplete statuses such as 'To do', 'Backlog', 'Not started', 'Pending'",
		team: 'Design System Team',
		status: 'published',
	},
	'status-workflow-paused': {
		keywords: [
			'status-workflow-paused',
			'statusworkflowpaused',
			'icon',
			'icon-lab',
			'status',
			'workflow phase',
			'pause',
			'paused',
		],
		componentName: 'StatusWorkflowPausedIcon',
		package: '@atlaskit/icon-lab/core/status-workflow-paused',
		categorization: 'single-purpose',
		usage: 'Reserved for representing statuses that indicate work or a process has paused',
		team: 'Design System Team',
		status: 'published',
	},
	'status-workflow-returned': {
		keywords: [
			'status-workflow-returned',
			'statusworkflowreturned',
			'icon',
			'icon-lab',
			'status',
			'workflow phase',
			'redeploy',
			'return',
			'revert',
			'rerun',
		],
		componentName: 'StatusWorkflowReturnedIcon',
		package: '@atlaskit/icon-lab/core/status-workflow-returned',
		categorization: 'single-purpose',
		usage:
			"Reserved for representing statuses that return to a previous state in the process such as 'Redeploy', 'Needs more information'",
		team: 'Design System Team',
		status: 'published',
	},
	'status-workflow-scheduled': {
		keywords: [
			'status-workflow-scheduled',
			'statusworkflowscheduled',
			'icon',
			'icon-lab',
			'status',
			'workflow phase',
			'waiting',
			'scheduled',
		],
		componentName: 'StatusWorkflowScheduledIcon',
		package: '@atlaskit/icon-lab/core/status-workflow-scheduled',
		categorization: 'single-purpose',
		usage:
			'Reserved for representing statuses that indicate work or a process is scheduled or waiting to commence',
		team: 'Design System Team',
		status: 'published',
	},
	'status-workflow-stopped': {
		keywords: [
			'status-workflow-stopped',
			'statusworkflowstopped',
			'icon',
			'icon-lab',
			'status',
			'workflow phase',
			'stop',
			'stopped',
		],
		componentName: 'StatusWorkflowStoppedIcon',
		package: '@atlaskit/icon-lab/core/status-workflow-stopped',
		categorization: 'single-purpose',
		usage: 'Reserved for representing statuses that indicate work or a process has stopped',
		team: 'Design System Team',
		status: 'published',
	},
	'status-workflow-success': {
		keywords: [
			'status-workflow-success',
			'statusworkflowsuccess',
			'icon',
			'icon-lab',
			'status',
			'workflow phase',
			'success',
			'accomplished',
			'achieved',
			'optimal state',
			'completed',
			'complete',
		],
		componentName: 'StatusWorkflowSuccessIcon',
		package: '@atlaskit/icon-lab/core/status-workflow-success',
		categorization: 'single-purpose',
		usage:
			'Reserved for representing statuses that signal positive outcome — success, accomplishment, achievement, or optimal state',
		team: 'Design System Team',
		status: 'published',
	},
	'status-workflow-warning': {
		keywords: [
			'status-workflow-warning',
			'statusworkflowwarning',
			'icon',
			'icon-lab',
			'status',
			'workflow phase',
			'warning',
			'alert',
			'awareness',
			'intervention',
		],
		componentName: 'StatusWorkflowWarningIcon',
		package: '@atlaskit/icon-lab/core/status-workflow-warning',
		categorization: 'single-purpose',
		usage:
			'Reserved for representing statuses that signal potential issues requiring awareness or intervention',
		team: 'Design System Team',
		status: 'published',
	},
	sticker: {
		keywords: ['sticker', 'icon', 'icon-lab', 'sticker', 'peel-off'],
		componentName: 'StickerIcon',
		package: '@atlaskit/icon-lab/core/sticker',
		categorization: 'multi-purpose',
		usage: 'Used for sticker tool in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'stroke-curvature-curved': {
		keywords: [
			'stroke-curvature-curved',
			'strokecurvaturecurved',
			'icon',
			'icon-lab',
			'line tool',
			'shape property',
			'stroke style',
			'border',
			'smooth',
		],
		componentName: 'StrokeCurvatureCurvedIcon',
		package: '@atlaskit/icon-lab/core/stroke-curvature-curved',
		categorization: 'single-purpose',
		usage: 'Reserved for curved line type setting for line tool in Whiteboards.',
		team: 'Whiteboards',
		status: 'published',
	},
	'stroke-curvature-dynamic': {
		keywords: [
			'stroke-curvature-dynamic',
			'strokecurvaturedynamic',
			'icon',
			'icon-lab',
			'line tool',
			'shape property',
			'stroke style',
			'border',
		],
		componentName: 'StrokeCurvatureDynamicIcon',
		package: '@atlaskit/icon-lab/core/stroke-curvature-dynamic',
		categorization: 'single-purpose',
		usage: 'Reserved for dynamic line type setting for line tool in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'stroke-curvature-straight': {
		keywords: [
			'stroke-curvature-straight',
			'strokecurvaturestraight',
			'icon',
			'icon-lab',
			'line tool',
			'shape property',
			'stroke style',
			'sharp corners',
			'border',
		],
		componentName: 'StrokeCurvatureStraightIcon',
		package: '@atlaskit/icon-lab/core/stroke-curvature-straight',
		categorization: 'single-purpose',
		usage: 'Reserved for straight line type setting for line tool in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'stroke-properties': {
		keywords: [
			'stroke-properties',
			'strokeproperties',
			'icon',
			'icon-lab',
			'stroke properties',
			'border options',
		],
		componentName: 'StrokePropertiesIcon',
		package: '@atlaskit/icon-lab/core/stroke-properties',
		categorization: 'single-purpose',
		usage: 'Reserved for stroke properties in Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	'stroke-style-dashed': {
		keywords: [
			'stroke-style-dashed',
			'strokestyledashed',
			'icon',
			'icon-lab',
			'border',
			'stroke',
			'border style',
			'dashed',
			'outline',
		],
		componentName: 'StrokeStyleDashedIcon',
		package: '@atlaskit/icon-lab/core/stroke-style-dashed',
		categorization: 'single-purpose',
		usage: 'Reserved for representing dashed stroke and border styles.',
		team: 'Whiteboards',
		status: 'published',
	},
	'stroke-style-dotted': {
		keywords: [
			'stroke-style-dotted',
			'strokestyledotted',
			'icon',
			'icon-lab',
			'border',
			'stroke',
			'border style',
			'dotted',
			'outline',
		],
		componentName: 'StrokeStyleDottedIcon',
		package: '@atlaskit/icon-lab/core/stroke-style-dotted',
		categorization: 'single-purpose',
		usage: 'Reserved for representing dotted stroke and border styles.',
		team: 'Whiteboards',
		status: 'published',
	},
	'stroke-style-solid': {
		keywords: [
			'stroke-style-solid',
			'strokestylesolid',
			'icon',
			'icon-lab',
			'border',
			'stroke',
			'border style',
			'solid',
			'outline',
		],
		componentName: 'StrokeStyleSolidIcon',
		package: '@atlaskit/icon-lab/core/stroke-style-solid',
		categorization: 'single-purpose',
		usage: 'Reserved for representing solid stroke and border styles.',
		team: 'Whiteboards',
		status: 'published',
	},
	studio: {
		keywords: ['studio', 'icon', 'icon-lab', 'studio', 'atlassian studio'],
		componentName: 'StudioIcon',
		package: '@atlaskit/icon-lab/core/studio',
		categorization: 'single-purpose',
		usage: 'Reserved for functional representation of Atlassian Studio',
		team: 'Design Systems Team',
		status: 'published',
	},
	'suggested-edit': {
		keywords: [
			'suggested-edit',
			'suggestededit',
			'icon',
			'icon-lab',
			'AI',
			'suggestion',
			'suggested edit',
			'suggest',
			'generative',
		],
		componentName: 'SuggestedEditIcon',
		package: '@atlaskit/icon-lab/core/suggested-edit',
		categorization: 'single-purpose',
		usage: 'Reserved for suggestions powered by Atlassian Intelligence',
		team: 'Editor AI',
		status: 'published',
	},
	sunset: {
		keywords: [
			'sunset',
			'icon',
			'icon-lab',
			'sun',
			'horizon',
			'farewell',
			'goodbye',
			'sky',
			'farewell feed',
		],
		componentName: 'SunsetIcon',
		package: '@atlaskit/icon-lab/core/sunset',
		categorization: 'multi-purpose',
		usage: 'Farewell feed in hello.',
		team: 'confluence insights',
		status: 'published',
	},
	survey: {
		keywords: [
			'survey',
			'icon',
			'icon-lab',
			'survey',
			'intake form',
			'clipboard',
			'questionnaire',
			'research',
		],
		componentName: 'SurveyIcon',
		package: '@atlaskit/icon-lab/core/survey',
		categorization: 'single-purpose',
		usage: 'Reserved for surveys.',
		team: 'Jira Service Management',
		status: 'published',
	},
	swap: {
		keywords: ['swap', 'icon', 'icon-lab', 'Swap', 'Jira status', 'Whiteboards', 'Smart section'],
		componentName: 'SwapIcon',
		package: '@atlaskit/icon-lab/core/swap',
		categorization: 'single-purpose',
		usage: 'Swapping between Jira tickets in Whiteboard smart section',
		team: 'Whiteboards',
		status: 'published',
	},
	'switch-case': {
		keywords: [
			'switch-case',
			'switchcase',
			'icon',
			'icon-lab',
			'conditions',
			'if',
			'else',
			'else if',
		],
		componentName: 'SwitchCaseIcon',
		package: '@atlaskit/icon-lab/core/switch-case',
		categorization: 'single-purpose',
		usage: 'Reserved for switch case conditions in automation',
		team: 'Automations',
		status: 'published',
		slackChannel: '#help-automation-design',
	},
	sync: {
		keywords: [
			'sync',
			'icon',
			'icon-lab',
			'sync',
			'synch',
			'synchronise',
			'synchronize',
			'saving',
			'arrows',
		],
		componentName: 'SyncIcon',
		package: '@atlaskit/icon-lab/core/sync',
		categorization: 'single-purpose',
		usage: 'Reserved for syncing changes and save operations.',
		team: 'Content Types',
		status: 'published',
	},
	tab: {
		keywords: ['tab', 'icon', 'icon-lab', 'key', 'tab'],
		componentName: 'TabIcon',
		package: '@atlaskit/icon-lab/core/tab',
		categorization: 'single-purpose',
		usage: 'Reserved for representing tab key.',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'table-row-limit': {
		keywords: [
			'table-row-limit',
			'tablerowlimit',
			'icon',
			'icon-lab',
			'table',
			'limit rows',
			'range',
		],
		componentName: 'TableRowLimitIcon',
		package: '@atlaskit/icon-lab/core/table-row-limit',
		categorization: 'single-purpose',
		usage: 'Reserved for limiting table rows.',
		team: 'Data Experiences',
		status: 'published',
	},
	tabs: {
		keywords: ['tabs', 'icon', 'icon-lab', 'tab', 'tabs'],
		componentName: 'TabsIcon',
		package: '@atlaskit/icon-lab/core/tabs',
		categorization: 'multi-purpose',
		usage: 'Known uses: tabs macro feature from the slash command menu in Editor.',
		team: 'Editor',
		status: 'published',
	},
	'takeout-container': {
		keywords: [
			'takeout-container',
			'takeoutcontainer',
			'icon',
			'icon-lab',
			'takeout',
			'food',
			'takeaway',
		],
		componentName: 'TakeoutContainerIcon',
		package: '@atlaskit/icon-lab/core/takeout-container',
		categorization: 'multi-purpose',
		usage: 'Known usages: Alternative option for food emoji category.',
		team: 'Design System Team',
		status: 'published',
	},
	talent: {
		keywords: ['talent', 'icon', 'icon-lab', 'talent', 'person', 'star'],
		componentName: 'TalentIcon',
		package: '@atlaskit/icon-lab/core/talent',
		categorization: 'single-purpose',
		usage: 'Reserved for functional representation of Talent app',
		team: 'Talent',
		status: 'published',
	},
	'teamwork-graph': {
		keywords: ['teamwork-graph', 'teamworkgraph', 'icon', 'icon-lab', 'teamwork graph'],
		componentName: 'TeamworkGraphIcon',
		package: '@atlaskit/icon-lab/core/teamwork-graph',
		categorization: 'single-purpose',
		usage: 'Reserved for Teamwork Graph features.',
		team: 'Teamwork Graph Experiences',
		status: 'published',
	},
	telescope: {
		keywords: ['telescope', 'icon', 'icon-lab', 'telescope', 'scope', 'discover', 'discovery'],
		componentName: 'TelescopeIcon',
		package: '@atlaskit/icon-lab/core/telescope',
		categorization: 'multi-purpose',
		usage: 'Known uses: Discover feature in Atlassian Home',
		team: 'Atlassian Home',
		status: 'published',
	},
	template: {
		keywords: ['template', 'icon', 'icon-lab', 'template', 'templates'],
		componentName: 'TemplateIcon',
		package: '@atlaskit/icon-lab/core/template',
		categorization: 'single-purpose',
		usage: 'Reserved fore templates.',
		team: 'Whiteboards',
		status: 'published',
	},
	'template-sync': {
		keywords: [
			'template-sync',
			'templatesync',
			'icon',
			'icon-lab',
			'template',
			'sync',
			'save',
			'update',
		],
		componentName: 'TemplateSyncIcon',
		package: '@atlaskit/icon-lab/core/template-sync',
		categorization: 'single-purpose',
		usage: 'Reserved for saving and updating templates.',
		team: 'Data Experiences',
		status: 'published',
	},
	terminal: {
		keywords: ['terminal', 'icon', 'icon-lab', 'terminal', 'IDE', 'code editor', 'command line'],
		componentName: 'TerminalIcon',
		package: '@atlaskit/icon-lab/core/terminal',
		categorization: 'multi-purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'text-adjust-length': {
		keywords: [
			'text-adjust-length',
			'textadjustlength',
			'icon',
			'icon-lab',
			'text length',
			'change text length',
			'adjust text length',
		],
		componentName: 'TextAdjustLengthIcon',
		package: '@atlaskit/icon-lab/core/text-adjust-length',
		categorization: 'single-purpose',
		usage: 'Reserved for accessing text length generative AI actions.',
		team: 'Editor AI',
		status: 'published',
	},
	'text-audio-transcript': {
		keywords: [
			'text-audio-transcript',
			'textaudiotranscript',
			'icon',
			'icon-lab',
			'microphone',
			'script',
			'paragraph',
		],
		componentName: 'TextAudioTranscriptIcon',
		package: '@atlaskit/icon-lab/core/text-audio-transcript',
		categorization: 'single-purpose',
		usage: 'Reserved for viewing transcript in Loom',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'text-bold-italic': {
		keywords: [
			'text-bold-italic',
			'textbolditalic',
			'icon',
			'icon-lab',
			'Text',
			'Type',
			'Font',
			'Bold',
			'Italic',
		],
		componentName: 'TextBoldItalicIcon',
		package: '@atlaskit/icon-lab/core/text-bold-italic',
		categorization: 'single-purpose',
		usage: 'Reserved for bold text with italic',
		team: 'Whiteboards',
		status: 'published',
	},
	'text-bold-italic-strikethrough': {
		keywords: [
			'text-bold-italic-strikethrough',
			'textbolditalicstrikethrough',
			'icon',
			'icon-lab',
			'Text',
			'Type',
			'strikethrough',
			'Bold',
			'Italic',
		],
		componentName: 'TextBoldItalicStrikethroughIcon',
		package: '@atlaskit/icon-lab/core/text-bold-italic-strikethrough',
		categorization: 'single-purpose',
		usage: 'Reserved for italic bold text with a strikethrough',
		team: 'Whiteboards',
		status: 'published',
	},
	'text-bold-italic-underline': {
		keywords: [
			'text-bold-italic-underline',
			'textbolditalicunderline',
			'icon',
			'icon-lab',
			'Text',
			'Type',
			'Font',
			'Bold',
			'Italic',
			'Underline',
		],
		componentName: 'TextBoldItalicUnderlineIcon',
		package: '@atlaskit/icon-lab/core/text-bold-italic-underline',
		categorization: 'single-purpose',
		usage: 'Reserved for bold italic text with underline',
		team: 'Whiteboards',
		status: 'published',
	},
	'text-bold-italic-underline-strikethrough': {
		keywords: [
			'text-bold-italic-underline-strikethrough',
			'textbolditalicunderlinestrikethrough',
			'icon',
			'icon-lab',
			'text formatting',
			'bold',
			'underline',
			'strikethrough',
			'italic',
		],
		componentName: 'TextBoldItalicUnderlineStrikethroughIcon',
		package: '@atlaskit/icon-lab/core/text-bold-italic-underline-strikethrough',
		categorization: 'single-purpose',
		usage: 'Reserved for bold italic text with underline and strikethrough',
		team: 'Whiteboards',
		status: 'published',
	},
	'text-bold-strikethrough': {
		keywords: [
			'text-bold-strikethrough',
			'textboldstrikethrough',
			'icon',
			'icon-lab',
			'Text',
			'Type',
			'Bold',
			'strikethrough',
		],
		componentName: 'TextBoldStrikethroughIcon',
		package: '@atlaskit/icon-lab/core/text-bold-strikethrough',
		categorization: 'single-purpose',
		usage: 'Reserved for bold strikethrough text',
		team: 'Whiteboards',
		status: 'published',
	},
	'text-bold-underline': {
		keywords: [
			'text-bold-underline',
			'textboldunderline',
			'icon',
			'icon-lab',
			'bold',
			'underline',
			'text formatting',
		],
		componentName: 'TextBoldUnderlineIcon',
		package: '@atlaskit/icon-lab/core/text-bold-underline',
		categorization: 'single-purpose',
		usage: 'Reserved for bold text with underline',
		team: 'Whiteboards',
		status: 'published',
	},
	'text-bold-underline-strikethrough': {
		keywords: [
			'text-bold-underline-strikethrough',
			'textboldunderlinestrikethrough',
			'icon',
			'icon-lab',
			'text formatting',
			'bold',
			'strikethrough',
			'underline',
		],
		componentName: 'TextBoldUnderlineStrikethroughIcon',
		package: '@atlaskit/icon-lab/core/text-bold-underline-strikethrough',
		categorization: 'single-purpose',
		usage: 'Reserved for bold text with underline and strikethrough',
		team: 'Whiteboards',
		status: 'published',
	},
	'text-conclusion-add': {
		keywords: [
			'text-conclusion-add',
			'textconclusionadd',
			'icon',
			'icon-lab',
			'text',
			'conclusion',
			'AI',
			'generative',
		],
		componentName: 'TextConclusionAddIcon',
		package: '@atlaskit/icon-lab/core/text-conclusion-add',
		categorization: 'single-purpose',
		usage: 'Confluence Editor AI action for generating a conclusion',
		team: 'Editor AI',
		status: 'published',
	},
	'text-cursor': {
		keywords: ['text-cursor', 'textcursor', 'icon', 'icon-lab', 'text cursor', 'rename'],
		componentName: 'TextCursorIcon',
		package: '@atlaskit/icon-lab/core/text-cursor',
		categorization: 'multi-purpose',
		usage: 'Known uses: Renaming',
		team: 'Data Experiences',
		status: 'published',
	},
	'text-density-compress': {
		keywords: [
			'text-density-compress',
			'textdensitycompress',
			'icon',
			'icon-lab',
			'text density',
			'compact density',
		],
		componentName: 'TextDensityCompressIcon',
		package: '@atlaskit/icon-lab/core/text-density-compress',
		categorization: 'single-purpose',
		usage: 'Reserved for increasing the density of text by reducing font size and/or line height.',
		team: 'Confluence',
		status: 'published',
	},
	'text-density-expand': {
		keywords: [
			'text-density-expand',
			'textdensityexpand',
			'icon',
			'icon-lab',
			'text density',
			'default density',
		],
		componentName: 'TextDensityExpandIcon',
		package: '@atlaskit/icon-lab/core/text-density-expand',
		categorization: 'single-purpose',
		usage: 'Reserved for reducing the density of text by increasing font size and/or line height.',
		team: 'Confluence',
		status: 'published',
	},
	'text-heading-five': {
		keywords: [
			'text-heading-five',
			'textheadingfive',
			'icon',
			'icon-lab',
			'heading 5',
			'H5',
			'text style',
		],
		componentName: 'TextHeadingFiveIcon',
		package: '@atlaskit/icon-lab/core/text-heading-five',
		categorization: 'single-purpose',
		usage: 'Reserved for H5 / Heading 5 text style',
		team: 'Editor design',
		status: 'published',
		slackChannel: '#editor-design',
	},
	'text-heading-four': {
		keywords: [
			'text-heading-four',
			'textheadingfour',
			'icon',
			'icon-lab',
			'heading 4',
			'H4',
			'text style',
		],
		componentName: 'TextHeadingFourIcon',
		package: '@atlaskit/icon-lab/core/text-heading-four',
		categorization: 'single-purpose',
		usage: 'Reserved for H4 / Heading 4 text style',
		team: 'Editor design',
		status: 'published',
		slackChannel: '#editor-design',
	},
	'text-heading-one': {
		keywords: [
			'text-heading-one',
			'textheadingone',
			'icon',
			'icon-lab',
			'Heading 1',
			'H1',
			'text style',
		],
		componentName: 'TextHeadingOneIcon',
		package: '@atlaskit/icon-lab/core/text-heading-one',
		categorization: 'single-purpose',
		usage: 'Reserved for H1 / Heading 1 text style',
		team: 'Editor design',
		status: 'published',
		slackChannel: '#Editor-design',
	},
	'text-heading-six': {
		keywords: [
			'text-heading-six',
			'textheadingsix',
			'icon',
			'icon-lab',
			'heading 6',
			'H6',
			'text style',
		],
		componentName: 'TextHeadingSixIcon',
		package: '@atlaskit/icon-lab/core/text-heading-six',
		categorization: 'single-purpose',
		usage: 'Reserved for H6 / Heading 6 text style',
		team: 'Editor design',
		status: 'published',
		slackChannel: '#editor-design',
	},
	'text-heading-three': {
		keywords: [
			'text-heading-three',
			'textheadingthree',
			'icon',
			'icon-lab',
			'heading 3',
			'H3',
			'text style',
		],
		componentName: 'TextHeadingThreeIcon',
		package: '@atlaskit/icon-lab/core/text-heading-three',
		categorization: 'single-purpose',
		usage: 'Reserved for H3 / Heading 3 text style',
		team: 'Editor design',
		status: 'published',
		slackChannel: '#editor-design',
	},
	'text-heading-two': {
		keywords: [
			'text-heading-two',
			'textheadingtwo',
			'icon',
			'icon-lab',
			'Heading 2',
			'H2',
			'text style',
		],
		componentName: 'TextHeadingTwoIcon',
		package: '@atlaskit/icon-lab/core/text-heading-two',
		categorization: 'single-purpose',
		usage: 'Reserved for H2 / Heading 2 text style',
		team: 'Editor design',
		status: 'published',
		slackChannel: '#editor-design',
	},
	'text-introduction-add': {
		keywords: [
			'text-introduction-add',
			'textintroductionadd',
			'icon',
			'icon-lab',
			'text',
			'introduction',
			'AI',
			'generative',
		],
		componentName: 'TextIntroductionAddIcon',
		package: '@atlaskit/icon-lab/core/text-introduction-add',
		categorization: 'single-purpose',
		usage: 'Confluence Editor AI action for generating an introduction',
		team: 'Editor AI',
		status: 'published',
	},
	'text-italic-strikethrough': {
		keywords: [
			'text-italic-strikethrough',
			'textitalicstrikethrough',
			'icon',
			'icon-lab',
			'Text',
			'Type',
			'Font',
			'Italic',
			'Strikethrough',
		],
		componentName: 'TextItalicStrikethroughIcon',
		package: '@atlaskit/icon-lab/core/text-italic-strikethrough',
		categorization: 'single-purpose',
		usage: 'Reserved for italic text with strikethrough',
		team: 'Whiteboards',
		status: 'published',
	},
	'text-italic-underline': {
		keywords: [
			'text-italic-underline',
			'textitalicunderline',
			'icon',
			'icon-lab',
			'Text',
			'Type',
			'Font',
			'Underline',
			'Italic',
		],
		componentName: 'TextItalicUnderlineIcon',
		package: '@atlaskit/icon-lab/core/text-italic-underline',
		categorization: 'single-purpose',
		usage: 'Reserved for italic text with underline',
		team: 'Whiteboards',
		status: 'published',
	},
	'text-italic-underline-strikethrough': {
		keywords: [
			'text-italic-underline-strikethrough',
			'textitalicunderlinestrikethrough',
			'icon',
			'icon-lab',
			'text formatting',
			'italic',
			'underline',
			'strikethrough',
		],
		componentName: 'TextItalicUnderlineStrikethroughIcon',
		package: '@atlaskit/icon-lab/core/text-italic-underline-strikethrough',
		categorization: 'single-purpose',
		usage: 'Reserved for italic text with underline and strikethrough',
		team: 'Whiteboards',
		status: 'published',
	},
	'text-lengthen': {
		keywords: [
			'text-lengthen',
			'textlengthen',
			'icon',
			'icon-lab',
			'text',
			'lengthen',
			'expand',
			'AI',
			'generative',
		],
		componentName: 'TextLengthenIcon',
		package: '@atlaskit/icon-lab/core/text-lengthen',
		categorization: 'single-purpose',
		usage: 'Lengthening text content with Atlassian Intelligence',
		team: 'Editor AI',
		status: 'published',
	},
	'text-letter-case': {
		keywords: [
			'text-letter-case',
			'textlettercase',
			'icon',
			'icon-lab',
			'text case',
			'letter case',
			'uppercase',
			'lowercase',
			'sentence case',
			'title case',
			'Aa',
		],
		componentName: 'TextLetterCaseIcon',
		package: '@atlaskit/icon-lab/core/text-letter-case',
		categorization: 'single-purpose',
		usage: 'Reserved for letter casing and text-transform',
		team: 'Design System Team',
		status: 'published',
		slackChannel: '#icon-contributions',
	},
	'text-normal': {
		keywords: [
			'text-normal',
			'textnormal',
			'icon',
			'icon-lab',
			'text style',
			'text regular',
			'text normal',
			'paragraph',
			'body',
		],
		componentName: 'TextNormalIcon',
		package: '@atlaskit/icon-lab/core/text-normal',
		categorization: 'single-purpose',
		usage: 'Reserved for representing Paragraph text style / Normal text style.',
		team: 'Confluence Lovability',
		status: 'published',
	},
	'text-paragraph': {
		keywords: [
			'text-paragraph',
			'textparagraph',
			'icon',
			'icon-lab',
			'text',
			'paragraph break',
			'AI',
			'generative',
			'reformat',
		],
		componentName: 'TextParagraphIcon',
		package: '@atlaskit/icon-lab/core/text-paragraph',
		categorization: 'multi-purpose',
		usage:
			'Confluence Editor AI action for reformatting paragraphs into multiple shorter paragraphs',
		team: 'Editor AI',
		status: 'published',
	},
	'text-rephrase': {
		keywords: [
			'text-rephrase',
			'textrephrase',
			'icon',
			'icon-lab',
			'text',
			'rephrase',
			'AI',
			'generative',
		],
		componentName: 'TextRephraseIcon',
		package: '@atlaskit/icon-lab/core/text-rephrase',
		categorization: 'single-purpose',
		usage: 'Confluence Editor AI action for rephrasing text',
		team: 'Editor AI',
		status: 'published',
	},
	'text-review': {
		keywords: ['text-review', 'textreview', 'icon', 'icon-lab', 'examine', 'text', 'review'],
		componentName: 'TextReviewIcon',
		package: '@atlaskit/icon-lab/core/text-review',
		categorization: 'single-purpose',
		usage: 'Editor action for reviewing text',
		team: 'Editor',
		status: 'published',
	},
	'text-small': {
		keywords: ['text-small', 'textsmall', 'icon', 'icon-lab', 'text style', 'sm', 'text small'],
		componentName: 'TextSmallIcon',
		package: '@atlaskit/icon-lab/core/text-small',
		categorization: 'single-purpose',
		usage: 'Reserved for representing small text style in text editor experiences.',
		team: 'Confluence Lovability',
		status: 'published',
	},
	'text-subscript': {
		keywords: [
			'text-subscript',
			'textsubscript',
			'icon',
			'icon-lab',
			'subscript',
			'text formatting',
		],
		componentName: 'TextSubscriptIcon',
		package: '@atlaskit/icon-lab/core/text-subscript',
		categorization: 'single-purpose',
		usage: 'Reserved for subscript text formatting.',
		team: 'Editor',
		status: 'published',
		slackChannel: '#editor-design',
	},
	'text-superscript': {
		keywords: [
			'text-superscript',
			'textsuperscript',
			'icon',
			'icon-lab',
			'superscript',
			'text formatting',
		],
		componentName: 'TextSuperscriptIcon',
		package: '@atlaskit/icon-lab/core/text-superscript',
		categorization: 'single-purpose',
		usage: 'Reserved for superscript text formatting.',
		team: 'Editor',
		status: 'published',
		slackChannel: '#Editor-design',
	},
	'text-underline-strikethrough': {
		keywords: [
			'text-underline-strikethrough',
			'textunderlinestrikethrough',
			'icon',
			'icon-lab',
			'text',
			'type',
			'font',
			'strikethrough',
			'underline',
		],
		componentName: 'TextUnderlineStrikethroughIcon',
		package: '@atlaskit/icon-lab/core/text-underline-strikethrough',
		categorization: 'single-purpose',
		usage: 'Reserved for underline text with a strikethrough',
		team: 'Whiteboards',
		status: 'published',
	},
	ticket: {
		keywords: ['ticket', 'icon', 'icon-lab', 'stub', 'ticket'],
		componentName: 'TicketIcon',
		package: '@atlaskit/icon-lab/core/ticket',
		categorization: 'multi-purpose',
		usage: 'Multi purpose',
		team: 'Design System Team',
		status: 'published',
	},
	tidy: {
		keywords: ['tidy', 'icon', 'icon-lab', 'Tidy', 'Clean up', 'Tidy up', 'Grid'],
		componentName: 'TidyIcon',
		package: '@atlaskit/icon-lab/core/tidy',
		categorization: 'single-purpose',
		usage: 'Tidy up objects on Whiteboards',
		team: 'Whiteboards',
		status: 'published',
	},
	variable: {
		keywords: ['variable', 'icon', 'icon-lab'],
		componentName: 'VariableIcon',
		package: '@atlaskit/icon-lab/core/variable',
		categorization: 'single-purpose',
		usage: 'Reserved for Variables functionality in Loom',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'vehicle-airplane': {
		keywords: [
			'vehicle-airplane',
			'vehicleairplane',
			'icon',
			'icon-lab',
			'plane',
			'airplane',
			'aeroplane',
			'travel',
			'vehicle',
		],
		componentName: 'VehicleAirplaneIcon',
		package: '@atlaskit/icon-lab/core/vehicle-airplane',
		categorization: 'multi-purpose',
		usage: 'User-selectable icon choice for calendars',
		team: 'Growth Buy',
		status: 'published',
	},
	'vehicle-train': {
		keywords: [
			'vehicle-train',
			'vehicletrain',
			'icon',
			'icon-lab',
			'transportation',
			'vehicle',
			'car',
		],
		componentName: 'VehicleTrainIcon',
		package: '@atlaskit/icon-lab/core/vehicle-train',
		categorization: 'multi-purpose',
		usage: 'Known usages: Alternative option for transport emoji category.',
		team: 'Design System Team',
		status: 'published',
	},
	'video-captions-stylized': {
		keywords: [
			'video-captions-stylized',
			'videocaptionsstylized',
			'icon',
			'icon-lab',
			'CC',
			'subtitles',
		],
		componentName: 'VideoCaptionsStylizedIcon',
		package: '@atlaskit/icon-lab/core/video-captions-stylized',
		categorization: 'single-purpose',
		usage: 'Reserved for stylized captions functionality in Loom',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'video-clip': {
		keywords: [
			'video-clip',
			'videoclip',
			'icon',
			'icon-lab',
			'film',
			'film strip',
			'video',
			'media',
			'file',
		],
		componentName: 'VideoClipIcon',
		package: '@atlaskit/icon-lab/core/video-clip',
		categorization: 'multi-purpose',
		usage: 'Known uses: add clip in Loom video editor',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'video-closed-captions': {
		keywords: [
			'video-closed-captions',
			'videoclosedcaptions',
			'icon',
			'icon-lab',
			'CC',
			'closed captions',
			'subtitles',
		],
		componentName: 'VideoClosedCaptionsIcon',
		package: '@atlaskit/icon-lab/core/video-closed-captions',
		categorization: 'single-purpose',
		usage: 'Reserved for enabling closed captions for videos.',
		team: 'Loom',
		status: 'published',
	},
	'video-closed-captions-filled': {
		keywords: ['video-closed-captions-filled', 'videoclosedcaptionsfilled', 'icon', 'icon-lab'],
		componentName: 'VideoClosedCaptionsFilledIcon',
		package: '@atlaskit/icon-lab/core/video-closed-captions-filled',
		categorization: 'single-purpose',
		usage: 'Reserved to show that closed captions are enabled for videos.',
		team: 'Loom',
		status: 'published',
	},
	'video-fast-forward': {
		keywords: [
			'video-fast-forward',
			'videofastforward',
			'icon',
			'icon-lab',
			'video',
			'media',
			'fast forward',
			'FFD',
			'BPMN shape',
			'diagram symbol',
		],
		componentName: 'VideoFastForwardIcon',
		package: '@atlaskit/icon-lab/core/video-fast-forward',
		categorization: 'single-purpose',
		usage: 'Reserved for fast forwarding media and representing fast forward BPMN diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'video-fast-forward-overlay': {
		keywords: [
			'video-fast-forward-overlay',
			'videofastforwardoverlay',
			'icon',
			'icon-lab',
			'video',
			'media',
			'fast forward',
			'FFD',
			'filled',
			'BPMN shape',
			'diagram symbol',
		],
		componentName: 'VideoFastForwardOverlayIcon',
		package: '@atlaskit/icon-lab/core/video-fast-forward-overlay',
		categorization: 'single-purpose',
		usage:
			'Reserved for fast forwarding media when icon is shown on an overlay, and representing fast forward BPMN diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'video-hd': {
		keywords: ['video-hd', 'videohd', 'icon', 'icon-lab', 'high definition', 'hi def'],
		componentName: 'VideoHdIcon',
		package: '@atlaskit/icon-lab/core/video-hd',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved for enabling high definition videos',
		team: 'Atlassian Design System',
		status: 'published',
	},
	'video-hd-filled': {
		keywords: ['video-hd-filled', 'videohdfilled', 'icon', 'icon-lab', 'high definition', 'hi def'],
		componentName: 'VideoHdFilledIcon',
		package: '@atlaskit/icon-lab/core/video-hd-filled',
		categorization: 'single-purpose',
		usage: 'Single purpose - Reserved to show that high definition is enabled for videos',
		team: 'Atlassian Design System',
		status: 'published',
	},
	'video-miniplayer': {
		keywords: [
			'video-miniplayer',
			'videominiplayer',
			'icon',
			'icon-lab',
			'picture in picture',
			'PIP',
		],
		componentName: 'VideoMiniplayerIcon',
		package: '@atlaskit/icon-lab/core/video-miniplayer',
		categorization: 'single-purpose',
		usage: 'Reserved for picture-in-picture functionality for videos.',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'video-overlay-tools': {
		keywords: [
			'video-overlay-tools',
			'videooverlaytools',
			'icon',
			'icon-lab',
			'overlays',
			'video',
			'add text',
			'add arrow',
			'add box',
		],
		componentName: 'VideoOverlayToolsIcon',
		package: '@atlaskit/icon-lab/core/video-overlay-tools',
		categorization: 'single-purpose',
		usage: 'Reserved for overlays over a video.',
		team: 'Loom',
		status: 'published',
	},
	'video-play-circle': {
		keywords: ['video-play-circle', 'videoplaycircle', 'icon', 'icon-lab', 'video', 'start'],
		componentName: 'VideoPlayCircleIcon',
		package: '@atlaskit/icon-lab/core/video-play-circle',
		categorization: 'multi-purpose',
		usage: 'Known uses: play video in Loom',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'video-record': {
		keywords: [
			'video-record',
			'videorecord',
			'icon',
			'icon-lab',
			'live',
			'circle',
			'ellipse',
			'recording',
		],
		componentName: 'VideoRecordIcon',
		package: '@atlaskit/icon-lab/core/video-record',
		categorization: 'single-purpose',
		usage: 'Reserved for when a video is recording',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'video-rewind': {
		keywords: [
			'video-rewind',
			'videorewind',
			'icon',
			'icon-lab',
			'video',
			'media',
			'playback control',
			'rewind',
			'RWD',
			'diagram symbol',
			'BPMN shape',
		],
		componentName: 'VideoRewindIcon',
		package: '@atlaskit/icon-lab/core/video-rewind',
		categorization: 'single-purpose',
		usage: 'Reserved for rewinding media and representing rewind diagram symbol.',
		team: 'Whiteboards',
		status: 'published',
	},
	'video-rewind-overlay': {
		keywords: [
			'video-rewind-overlay',
			'videorewindoverlay',
			'icon',
			'icon-lab',
			'rewind back',
			'video',
			'media',
			'playback control',
			'rewind',
			'RWD',
			'diagram symbol',
			'BPMN shape',
			'filled',
		],
		componentName: 'VideoRewindOverlayIcon',
		package: '@atlaskit/icon-lab/core/video-rewind-overlay',
		categorization: 'single-purpose',
		usage: 'Reserved for rewinding media and representing rewind diagram symbol.',
		team: 'Loom',
		status: 'published',
	},
	'video-skip-backward-five': {
		keywords: [
			'video-skip-backward-five',
			'videoskipbackwardfive',
			'icon',
			'icon-lab',
			'video',
			'media',
			'skip',
			'forward',
			'5',
			'seconds',
		],
		componentName: 'VideoSkipBackwardFiveIcon',
		package: '@atlaskit/icon-lab/core/video-skip-backward-five',
		categorization: 'single-purpose',
		usage: 'Reserved for skipping video content backward by 5 seconds.',
		team: 'Loom',
		status: 'published',
	},
	'video-skip-forward-five': {
		keywords: [
			'video-skip-forward-five',
			'videoskipforwardfive',
			'icon',
			'icon-lab',
			'video',
			'media',
			'skip',
			'forward',
			'5',
			'seconds',
		],
		componentName: 'VideoSkipForwardFiveIcon',
		package: '@atlaskit/icon-lab/core/video-skip-forward-five',
		categorization: 'single-purpose',
		usage: 'Reserved for skipping video content forward by 5 seconds.',
		team: 'Loom',
		status: 'published',
	},
	'video-strikethrough': {
		keywords: [
			'video-strikethrough',
			'videostrikethrough',
			'icon',
			'icon-lab',
			'video',
			'no video',
			'camera off',
			'off',
		],
		componentName: 'VideoStrikethroughIcon',
		package: '@atlaskit/icon-lab/core/video-strikethrough',
		categorization: 'multi-purpose',
		usage: 'Reserved for no video input',
		team: 'Loom',
		status: 'published',
	},
	'video-theater-mode': {
		keywords: [
			'video-theater-mode',
			'videotheatermode',
			'icon',
			'icon-lab',
			'theater mode',
			'view',
			'viewport',
			'video',
			'wide',
		],
		componentName: 'VideoTheaterModeIcon',
		package: '@atlaskit/icon-lab/core/video-theater-mode',
		categorization: 'single-purpose',
		usage: 'Reserved for theater mode functionality within video player.',
		team: 'Loom',
		status: 'published',
	},
	'video-timeline-clip-insert-end': {
		keywords: [
			'video-timeline-clip-insert-end',
			'videotimelineclipinsertend',
			'icon',
			'icon-lab',
			'video',
			'clip',
			'timeline',
			'end',
		],
		componentName: 'VideoTimelineClipInsertEndIcon',
		package: '@atlaskit/icon-lab/core/video-timeline-clip-insert-end',
		categorization: 'single-purpose',
		usage: 'Reserved for inserting a clip at the end of the video timeline in Loom.',
		team: 'Loom',
		status: 'published',
	},
	'video-timeline-clip-insert-playhead': {
		keywords: [
			'video-timeline-clip-insert-playhead',
			'videotimelineclipinsertplayhead',
			'icon',
			'icon-lab',
			'video',
			'clip',
			'timeline',
			'playhead',
			'current position',
		],
		componentName: 'VideoTimelineClipInsertPlayheadIcon',
		package: '@atlaskit/icon-lab/core/video-timeline-clip-insert-playhead',
		categorization: 'single-purpose',
		usage: 'Reserved for inserting a clip at the playhead position of the video timeline in Loom.',
		team: 'Loom',
		status: 'published',
	},
	'video-timeline-clip-insert-start': {
		keywords: [
			'video-timeline-clip-insert-start',
			'videotimelineclipinsertstart',
			'icon',
			'icon-lab',
			'video',
			'clip',
			'timeline',
			'start',
			'beginning',
		],
		componentName: 'VideoTimelineClipInsertStartIcon',
		package: '@atlaskit/icon-lab/core/video-timeline-clip-insert-start',
		categorization: 'single-purpose',
		usage: 'Reserved for inserting a clip at the beginning of the video timeline in Loom.',
		team: 'Loom',
		status: 'published',
	},
	'video-timeline-clip-split': {
		keywords: [
			'video-timeline-clip-split',
			'videotimelineclipsplit',
			'icon',
			'icon-lab',
			'split',
			'clip',
			'edit',
			'enhance',
			'video',
			'timeline',
			'trim',
		],
		componentName: 'VideoTimelineClipSplitIcon',
		package: '@atlaskit/icon-lab/core/video-timeline-clip-split',
		categorization: 'single-purpose',
		usage: 'Reserved for split clip functionality in Loom.',
		team: 'Loom',
		status: 'published',
	},
	'video-timeline-editor': {
		keywords: [
			'video-timeline-editor',
			'videotimelineeditor',
			'icon',
			'icon-lab',
			'track',
			'edit',
			'video',
		],
		componentName: 'VideoTimelineEditorIcon',
		package: '@atlaskit/icon-lab/core/video-timeline-editor',
		categorization: 'single-purpose',
		usage: 'Reserved for timeline editor functionality in Loom',
		team: 'Loom',
		status: 'published',
		slackChannel: '#feedback-loom-vizrefresh',
	},
	'video-watch-later-remove': {
		keywords: [
			'video-watch-later-remove',
			'videowatchlaterremove',
			'icon',
			'icon-lab',
			'bookmark',
			'x',
			'remove',
			'cross',
		],
		componentName: 'VideoWatchLaterRemoveIcon',
		package: '@atlaskit/icon-lab/core/video-watch-later-remove',
		categorization: 'single-purpose',
		usage: 'Reserved for watch later functionality in Loom',
		team: 'Loom',
		status: 'published',
	},
	'video-watch-later-saved': {
		keywords: [
			'video-watch-later-saved',
			'videowatchlatersaved',
			'icon',
			'icon-lab',
			'bookmark',
			'check',
			'saved',
		],
		componentName: 'VideoWatchLaterSavedIcon',
		package: '@atlaskit/icon-lab/core/video-watch-later-saved',
		categorization: 'single-purpose',
		usage: 'Reserved for watch later functionality in Loom',
		team: 'Loom',
		status: 'published',
	},
	'view-split': {
		keywords: [
			'view-split',
			'viewsplit',
			'icon',
			'icon-lab',
			'2 col',
			'two columns',
			'split view',
			'side-by-side',
			'layout',
		],
		componentName: 'ViewSplitIcon',
		package: '@atlaskit/icon-lab/core/view-split',
		categorization: 'single-purpose',
		usage: 'Reserved for representing a 2 column split view.',
		team: 'Confluence',
		status: 'published',
	},
	'view-type-board-home': {
		keywords: [
			'view-type-board-home',
			'viewtypeboardhome',
			'icon',
			'icon-lab',
			'board view',
			'databases',
			'home',
			'default view',
		],
		componentName: 'ViewTypeBoardHomeIcon',
		package: '@atlaskit/icon-lab/core/view-type-board-home',
		categorization: 'single-purpose',
		usage: 'Home view for database board layout',
		team: 'Databases',
		status: 'published',
	},
	'view-type-card-home': {
		keywords: [
			'view-type-card-home',
			'viewtypecardhome',
			'icon',
			'icon-lab',
			'card view',
			'databases',
			'home',
			'default view',
		],
		componentName: 'ViewTypeCardHomeIcon',
		package: '@atlaskit/icon-lab/core/view-type-card-home',
		categorization: 'single-purpose',
		usage: 'Home view for database card layout',
		team: 'Databases',
		status: 'published',
	},
	'view-type-table-home': {
		keywords: [
			'view-type-table-home',
			'viewtypetablehome',
			'icon',
			'icon-lab',
			'table view',
			'databases',
			'home',
			'default view',
		],
		componentName: 'ViewTypeTableHomeIcon',
		package: '@atlaskit/icon-lab/core/view-type-table-home',
		categorization: 'single-purpose',
		usage: 'Home view for database table layout',
		team: 'Databases',
		status: 'published',
	},
	views: {
		keywords: ['views', 'icon', 'icon-lab', 'saved views', 'view types'],
		componentName: 'ViewsIcon',
		package: '@atlaskit/icon-lab/core/views',
		categorization: 'single-purpose',
		usage: 'Reserved for representing saved views.',
		team: 'Platforms Apps',
		status: 'published',
	},
	vulnerability: {
		keywords: [
			'vulnerability',
			'icon',
			'icon-lab',
			'vulnerability',
			'security',
			'alert',
			'warning',
		],
		componentName: 'VulnerabilityIcon',
		package: '@atlaskit/icon-lab/core/vulnerability',
		categorization: 'single-purpose',
		usage: 'Reserved for security vulnerabilities.',
		team: 'Automation',
		status: 'published',
	},
	wallet: {
		keywords: ['wallet', 'icon', 'icon-lab', 'money', 'sales', 'payment', 'wallet'],
		componentName: 'WalletIcon',
		package: '@atlaskit/icon-lab/core/wallet',
		categorization: 'multi-purpose',
		usage: 'Multi purpose',
		team: 'Design System Team',
		status: 'published',
	},
	'warning-outline': {
		keywords: [
			'warning-outline',
			'warningoutline',
			'icon',
			'icon-lab',
			'warning',
			'exclamation',
			'overdue',
			'past due',
			'late',
		],
		componentName: 'WarningOutlineIcon',
		package: '@atlaskit/icon-lab/core/warning-outline',
		categorization: 'multi-purpose',
		usage: 'Low-impact warnings. Overdue dates in Atlassian Home.',
		team: 'Atlassian Home',
		status: 'published',
	},
	webhook: {
		keywords: ['webhook', 'icon', 'icon-lab', 'api', 'callback', 'payload'],
		componentName: 'WebhookIcon',
		package: '@atlaskit/icon-lab/core/webhook',
		categorization: 'single-purpose',
		usage: 'Reserved for using a webhook to send data between applications via HTTP',
		team: 'Automation',
		status: 'published',
		slackChannel: '#help-automation-design',
	},
	'welcome-feed': {
		keywords: [
			'welcome-feed',
			'welcomefeed',
			'icon',
			'icon-lab',
			'welcome',
			'hello',
			'blog',
			'smile',
			'intro',
		],
		componentName: 'WelcomeFeedIcon',
		package: '@atlaskit/icon-lab/core/welcome-feed',
		categorization: 'multi-purpose',
		usage: 'Known uses: Intro blog feed picker on Hello',
		team: 'Insights',
		status: 'published',
		slackChannel: '#cc-insights-and-reporting',
	},
	'work-item-add': {
		keywords: [
			'work-item-add',
			'workitemadd',
			'icon',
			'icon-lab',
			'work item',
			'work type',
			'add',
			'plus',
			'create',
		],
		componentName: 'WorkItemAddIcon',
		package: '@atlaskit/icon-lab/core/work-item-add',
		categorization: 'single-purpose',
		usage: 'Reserved for adding or creating a new work item.',
		team: 'Jira',
		status: 'published',
	},
	'workflow-controls': {
		keywords: ['workflow-controls', 'workflowcontrols', 'icon', 'icon-lab', 'orchestration'],
		componentName: 'WorkflowControlsIcon',
		package: '@atlaskit/icon-lab/core/workflow-controls',
		categorization: 'single-purpose',
		usage: 'Reserved for workflow controls in automation',
		team: 'Automation',
		status: 'published',
		slackChannel: '#help-automation-design',
	},
	world: {
		keywords: ['world', 'icon', 'icon-lab', 'world', 'globe', 'atlas', 'geography'],
		componentName: 'WorldIcon',
		package: '@atlaskit/icon-lab/core/world',
		categorization: 'multi-purpose',
		usage: 'Known uses: Geographical data visualization.',
		team: 'Data Experiences',
		status: 'published',
	},
	wrench: {
		keywords: ['wrench', 'icon', 'icon-lab', 'wrench', 'spanner', 'tool'],
		componentName: 'WrenchIcon',
		package: '@atlaskit/icon-lab/core/wrench',
		categorization: 'multi-purpose',
		usage: 'Multi purpose',
		team: 'Design System Team',
		status: 'published',
	},
};

export default metadata;
